/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B010010 受注入力
 */

import { Column } from "@material-table/core";
import { Box } from "@mui/system";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialogAction,
  SDateField,
  SEntryTab,
  SFrame,
  SInfoButton,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import {
  ChohaKbn,
  getSCode,
  HasokbnCd,
  HasosakiCd,
  JuchuKbn,
  NetsukeKbn,
  PpgakeKbn,
  SCode,
  JuchuUchiwakeKbn,
  ZeiKbn,
  JuchuSeisanhinKbn,
  HyoziKazeiKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import {
  B000111,
  B000111Props,
  B000140,
  B000140Props,
  B000150,
  B000151,
  B000190,
  B000200,
  B000220,
  B000220Props,
  B010011Props,
} from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, useFocus } from "states";
import {
  B010010Create,
  B010010Update,
  B010010Tokui,
  B010010ZeiRitsu,
  B010010Nonyu,
  B000111Biko,
  B000111Meisaibiko,
  B000111LineNm,
  B000140Shain,
  B000140AssistantNm,
  B000111DenpyoshubetsuNmAndTenpudenpyo,
  B000111TenpudenpyoNmByDenpyoshubetsu,
  B000111UnsogaishaNm,
  B010010HandleChangeShohinCd,
  B010010HandleChangeJanCd,
  B010010Kanosu,
  B010020GetResponse,
  B010010Shohin,
  B010010WhTanka,
  catchRestError,
  B000190SokoNmSokoshubetsuKbn,
  B010010TankaList,
  B010010ShohinZaiko,
  B010010Tanka,
} from "clients/rest";
import {
  date,
  validDate,
  getJuchutanka,
  getJuchuKin,
  getHitsuyosu,
  getKakeritsu,
  digit,
  getJodaitanka,
  getUchizeiJuchutanka,
} from "services";
import Big, { RoundingMode } from "big.js";
import { B010011, B010012, B010012Props } from "pages";
import {
  editKbn,
  juchuKbn,
  juchuSeisanhinKbn,
  meishoKbn,
  setshohinKbn,
  shohinShokuchiKbn,
  shohinshubetsuKbn,
  shokuchiKbn,
  sokoshubetsuKbn,
  tankaKbn,
  tenyuryokujodaiKbn,
  tenyuryokujuchuKbn,
  zeiKbn,
  zeimarumeKbn,
} from "services/codes";
import { getClientError, getClientMessage } from "messages";
import { B010010CreateRequestFieldName } from "clients/rest/fieldName/b010/B010010";

// TODO: 詳細設計 テーブル カラムID[setshohin_kbn]がスネークケースになっている
// TODO: 詳細設計 表示順[hyojijun]は全て削除する。
// TODO: 詳細設計 受注伝票No.はコード値のため、文字列。
// TODO: 詳細設計 発送先名、発送区分名はリストボックスに含まれるため不要
// TODO: 詳細設計 登録完了後の画面表示について
// TODO: 詳細設計 処理「商品名表示」に「商品関連項目設定処理を呼び出す。」を追記
// TODO: 詳細設計 明細データにversionは不要
// TODO: 詳細設計 セット構成品データにcrtDate、crtshainCdを追加
// TODO: 発送区分、発送先はダイアログにする必要あり。
// TODO: 戻るボタンの実装
// TODO: 登録・更新時にフィールドチェックを実施する。
/* TODO:
・受注入力、受注照会のget
　セット構成品データに登録ユーザ、登録日付を追加(restClientも修正)
　金額丸め区分を削除する
　edi区分を削除する
*/

export type B010010InputData = {
  editKbn: string;
  juchu: B010020GetResponse;
};

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// フィールド定義
type Fields = Partial<{
  editKbn: string;
  juchuKbn: SCode;
  juchudenpyoNo: string;
  juchuYmd: string | null;
  nohinyoteiYmd: string | null;
  tokuiShokuchiKbn: number;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  tankaKakeritsu: string;
  zeimarumeKbn: number;
  kinmarumeKbn: number;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuShokuchiKbn: number;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  ediMemo: string;
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  seisakuYmd: string | null;
  shukayoteiYmd: string | null;
  jisanYmd: string | null;
  denpyoYmd: string | null;
  shimeD: string;
  chohaKbn: SCode;
  hasosakiCd: SCode;
  hasokbnCd: SCode;
  zeiKbnView: SCode;
  zeiKbn: string;
  assistantCd: string;
  assistantNm: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  bunrui: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bumonCd: string;
  bumonNm: string;
  ppgakeKbn: SCode;
  netsukeKbn: SCode;
  denpyoKbn: string;
  chumonNo: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  bikoCdBefore: string;
  nohinsaki: string;
  lineCd: string;
  lineNm: string;
  uribaNm: string;
  naisen: string;
  juchuKinGokei: string;
  zeiGokei: string;
  denpyoGokei: string;
  edijuchuNo: string;
  version: string;
  zeiRitsu: string;
  jodaihyojiKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  dirtyFields: {
    tokuiCd: string;
    tokuishitenCd: string;
    nonyuCd: string;
    nonyushitenCd: string;
    shainCd: string;
    assistantCd: string;
    denpyoshubetsuCd: string;
    tenpudenpyoCd: string;
    unsogaishaCd: string;
    denpyoYmd: string;
  };
}>;

//明細入力部
export type MeiFields = MeiData &
  Partial<{
    meiTab: boolean;
    dirtyFields: {
      shohinCd: string;
      janCd: string;
      sokoCd: string;
      sotosunW: string;
      sotosunH: string;
      juchusu: string;
      jodaitanka: string;
      juchutanka: string;
      kakeritsu: string;
    };
  }>;

// 明細データ
export type MeiData = Partial<{
  juchugyoNo: number;
  uchiwakeKbn: SCode;
  juchuSeisanhinKbn: SCode;
  shohinCd: string;
  shohinCdBefore: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  juchusu: string;
  kanosu: string;
  juchusuBefore: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibikoCdBefore: string;
  meisaibiko: string;
  kazeiKbnView: string;
  kazeiKbn: number;
  setshohinKbn: number;
  edishohinNm: string;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  sokoshubetsuKbn: number;
  zairyohikiatesuBefore: string;
  zairyohikiateKanoNagasa: string;
  zairyohikiateNagasa: string;
  koseiData: KoseiData[];
}>;

// セット構成品データ定義
export type KoseiData = Partial<{
  juchugyoNo: number;
  juchukoseigyoNo: number;
  shohinCd: string;
  shohinCdBefore: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  hitsuyosu: string;
  hitsuyosuBefore: string;
  koseisu: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: number;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  sokoshubetsuKbn: number;
  setshohinKbn: number;
  zairyohikiatesuBefore: string;
  zairyohikiateKanoNagasa: string;
  zairyohikiateNagasa: string;
  crtDate: string;
  crtshainCd: string;
}>;

// 明細テーブルデータ定義
type Data = Partial<{
  juchugyoNo: number;
  uchiwakeKbnView: string;
  uchiwakeKbn: string;
  juchuSeisanhinKbnView: string;
  juchuSeisanhinKbn: string;
  shohinCd: string;
  shohinCdBefore: string;
  janCd: string;
  shohinNm: string;
  edishohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunView: string;
  uchisunView: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  juchusu: string;
  juchusuBefore: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbnView: string;
  kazeiKbn: number;
  setshohinKbn: number;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  sokoshubetsuKbn: number;
  zairyohikiatesuBefore: string;
  zairyohikiateKanoNagasa: string;
  zairyohikiateNagasa: string;
  koseiData: KoseiData[];
}>;

// フィールド初期値
const defaultFields: Fields = {
  editKbn: editKbn.register,
  juchuKbn: getSCode(JuchuKbn, "0"),
  juchudenpyoNo: "",
  juchuYmd: date(),
  nohinyoteiYmd: null,
  tokuiShokuchiKbn: undefined,
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  tankaKakeritsu: "",
  zeimarumeKbn: undefined,
  kinmarumeKbn: undefined,
  tokuiPostCd: "",
  tokuiAddress1: "",
  tokuiAddress2: "",
  tokuiTelNo: "",
  tokuiFaxNo: "",
  nonyuShokuchiKbn: undefined,
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  nonyuPostCd: "",
  nonyuAddress1: "",
  nonyuAddress2: "",
  nonyuTelNo: "",
  nonyuFaxNo: "",
  ediMemo: "",
  shainCd: "",
  shainNm: "",
  eigyoCd: "",
  seisakuYmd: null,
  shukayoteiYmd: null,
  jisanYmd: null,
  denpyoYmd: date(),
  shimeD: "",
  chohaKbn: getSCode(ChohaKbn, "0"),
  hasosakiCd: getSCode(HasosakiCd, "0"),
  hasokbnCd: getSCode(HasokbnCd, "0"),
  zeiKbnView: getSCode(ZeiKbn, ""),
  zeiKbn: "",
  assistantCd: "",
  assistantNm: "",
  denpyoshubetsuCd: "",
  denpyoshubetsuNm: "",
  tenpudenpyoCd: "",
  tenpudenpyoNm: "",
  bunrui: "",
  unsogaishaCd: "",
  unsogaishaNm: "",
  bumonCd: "",
  bumonNm: "",
  ppgakeKbn: getSCode(PpgakeKbn, "0"),
  netsukeKbn: getSCode(NetsukeKbn, "0"),
  denpyoKbn: "",
  chumonNo: "",
  ritsu: "",
  hinbetsuNo: "",
  tantosha: "",
  bikoCd: "",
  biko: "",
  bikoCdBefore: "",
  nohinsaki: "",
  lineCd: "",
  lineNm: "",
  uribaNm: "",
  naisen: "",
  juchuKinGokei: "",
  zeiGokei: "",
  denpyoGokei: "",
  edijuchuNo: "",
  version: "",
  zeiRitsu: "",
  jodaihyojiKbn: "",
  tankamarumeKbn: "",
  tankahasuichi: "",
  dirtyFields: {
    tokuiCd: "",
    tokuishitenCd: "",
    nonyuCd: "",
    nonyushitenCd: "",
    shainCd: "",
    assistantCd: "",
    denpyoshubetsuCd: "",
    tenpudenpyoCd: "",
    unsogaishaCd: "",
    denpyoYmd: date(),
  },
};

// 明細フィールド初期値
const defaultMeiFields: MeiFields = {
  meiTab: true,
  dirtyFields: {
    shohinCd: "",
    janCd: "",
    sokoCd: "",
    sotosunW: "",
    sotosunH: "",
    juchusu: "",
    jodaitanka: "",
    juchutanka: "",
    kakeritsu: "",
  },
  juchugyoNo: undefined,
  uchiwakeKbn: getSCode(JuchuUchiwakeKbn, "0"),
  juchuSeisanhinKbn: getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi),
  shohinCd: "",
  shohinCdBefore: "",
  janCd: "",
  shohinNm: "",
  aiteCd: "",
  sokoCd: "",
  sokoNm: "",
  vol: "",
  sotosunW: "",
  sotosunH: "",
  uchisunW: "",
  uchisunH: "",
  juchusu: "",
  juchusuBefore: "",
  kanosu: "",
  tenyuryokujodaiKbn: undefined,
  tenyuryokujuchuKbn: undefined,
  basejodaitanka: undefined,
  basejuchutanka: undefined,
  jodaitanka: "",
  juchutanka: "",
  kakeritsu: "",
  juchuKin: "",
  meisaibikoCd: "",
  meisaibikoCdBefore: "",
  meisaibiko: "",
  kazeiKbnView: "",
  kazeiKbn: undefined,
  setshohinKbn: undefined,
  edishohinNm: "",
  crtDate: "",
  crtshainCd: "",
  shohinshubetsuKbn: undefined,
  tankaKbn: undefined,
  shokuchiKbn: undefined,
  whtankaCd: "",
  sokoshubetsuKbn: undefined,
  zairyohikiatesuBefore: "",
  zairyohikiateKanoNagasa: "",
  zairyohikiateNagasa: "",
  koseiData: [],
};

// テーブル設定
const columns: Column<Data>[] = [
  { field: "juchugyoNo", title: "行", width: "3rem", align: "right" },
  { field: "uchiwakeKbnView", title: "区分", width: "3.5rem" },
  { field: "uchiwakeKbn", title: "内訳区分", hidden: true },
  { field: "juchuSeisanhinKbnView", title: "受注生産品", width: "4.5rem" },
  {
    field: "juchuSeisanhinKbn",
    title: "受注生産品",
    hidden: true,
  },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  { field: "shohinCdBefore", title: "商品コード(変更前)", hidden: true },
  { field: "janCd", title: "JAN コード	", hidden: true },
  { field: "shohinNm", title: "商品名", width: "10rem" },
  { field: "edishohinNm", title: "EDI商品名", width: "7rem" },
  { field: "aiteCd", title: "相手コード", hidden: true },
  { field: "vol", title: "VOL", width: "5rem" },
  {
    field: "sotosunView",
    title: "WH(外)",
    width: "6rem",
    render: (data) => {
      if (data.sotosunW && Number(data.sotosunW) > 0) {
        return data.sotosunW + " x " + data.sotosunH;
      }
    },
  },
  {
    field: "uchisunView",
    title: "WH(内)",
    width: "6rem",
    render: (data) => {
      if (data.uchisunW && Number(data.uchisunW) > 0) {
        return data.uchisunW + " x " + data.uchisunH;
      }
    },
  },
  { field: "sotosunH", title: "外高さ", hidden: true },
  { field: "sotosunW", title: "外幅", hidden: true },
  { field: "uchisunW", title: "内幅", hidden: true },
  { field: "uchisunH", title: "内高さ", hidden: true },
  {
    field: "juchusu",
    title: "受注数",
    width: "4rem",
    align: "right",
    render: (data) => digit(data.juchusu),
  },
  { field: "juchusuBefore", title: "受注数(変更前)", hidden: true },
  {
    field: "kanosu",
    title: "可能数",
    width: "4rem",
    align: "right",
    render: (data) => digit(data.kanosu),
  },
  { field: "tenyuryokujodaiKbn", title: "手入力上代区分", hidden: true },
  { field: "tenyuryokujuchuKbn", title: "手入力受注区分", hidden: true },
  { field: "basejodaitanka", title: "ベース上代単価", hidden: true },
  { field: "basejuchutanka", title: "ベース下代単価", hidden: true },
  {
    field: "jodaitanka",
    title: "上代",
    width: "4rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.jodaitanka)}</Box>;
    },
  },
  {
    field: "juchutanka",
    title: "下代	",
    width: "4rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokujuchuKbn === tenyuryokujuchuKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.juchutanka)}</Box>;
    },
  },
  { field: "kakeritsu", title: "掛率", width: "3rem", align: "right" },
  {
    field: "juchuKin",
    title: "受注金額	",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.juchuKin),
  },
  { field: "meisaibikoCd", title: "明細備考コード", hidden: true },
  { field: "meisaibiko", title: "明細備考", width: "20rem" },
  { field: "sokoCd", title: "倉庫コード", width: "5rem" },
  { field: "sokoNm", title: "倉庫名", width: "10rem" },
  {
    field: "kazeiKbnView",
    title: "税",
    width: "4rem",
    render: (data) => getSCode(HyoziKazeiKbn, data.kazeiKbn ?? "")?.label,
  },
  { field: "kazeiKbn", title: "課税区分", width: "4rem", hidden: true },
  { field: "setshohinKbn", title: "セット商品区分", hidden: true },
  { field: "crtDate", hidden: true },
  { field: "crtshainCd", hidden: true },
  { field: "shohinshubetsuKbn", title: "商品種別区分", hidden: true },
  { field: "tankaKbn", title: "単価区分", hidden: true },
  { field: "shokuchiKbn", title: "諸口区分", hidden: true },
  { field: "whtankaCd", title: "WH 単価コード", hidden: true },
  { field: "sokoshubetsuKbn", title: "倉庫種別区分", hidden: true },
  { field: "zairyohikiatesuBefore", title: "材料引当数(変更前)", hidden: true },
  {
    field: "zairyohikiateKanoNagasa",
    title: "前回分を考慮した引当可能な長さ",
    hidden: true,
  },
  { field: "zairyohikiateNagasa", title: "今回必要な長さ", hidden: true },
  { field: "koseiData", title: "セット構成品データ", hidden: true },
];

// 固定値
const tokuiCd = "000100";
const tokuishitenCd = "0000";
const juchusuMin = 0;
const KakerituRangeMin = 0;
const KakerituRangeMax = 999;
const juchuKinMaxLength = 9;
const jodaitankaMaxLength = 9;
const juchutankaMaxLength = 9;
const whMin = 0;

const focusId = "B010010";
const torihikishuryoYmd = date();

// B010010 受注入力
export const B010010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};
const Page = (props: Props) => {
  console.log("rendering: B010010");
  // 初期設定
  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });

  // dirtyFields初期化
  const resetDirtyFields = () => {
    const fields = methods.getValues();
    methods.setValue("dirtyFields.tokuiCd", fields.tokuiCd ?? "");
    methods.setValue("dirtyFields.tokuishitenCd", fields.tokuishitenCd ?? "");
    methods.setValue("dirtyFields.nonyuCd", fields.nonyuCd ?? "");
    methods.setValue("dirtyFields.nonyushitenCd", fields.nonyushitenCd ?? "");
    methods.setValue("dirtyFields.shainCd", fields.shainCd ?? "");
    methods.setValue("dirtyFields.assistantCd", fields.assistantCd ?? "");
    methods.setValue(
      "dirtyFields.denpyoshubetsuCd",
      fields.denpyoshubetsuCd ?? ""
    );
    methods.setValue("dirtyFields.tenpudenpyoCd", fields.tenpudenpyoCd ?? "");
    methods.setValue("dirtyFields.unsogaishaCd", fields.unsogaishaCd ?? "");
    methods.setValue("dirtyFields.denpyoYmd", fields.denpyoYmd ?? "");
  };
  const resetMeiDirtyFields = () => {
    const fields = meiMethods.getValues();
    meiMethods.setValue("dirtyFields.shohinCd", fields.shohinCd ?? "");
    meiMethods.setValue("dirtyFields.janCd", fields.janCd ?? "");
    meiMethods.setValue("dirtyFields.sokoCd", fields.sokoCd ?? "");
    meiMethods.setValue("dirtyFields.sotosunW", fields.sotosunW ?? "");
    meiMethods.setValue("dirtyFields.sotosunH", fields.sotosunH ?? "");
    meiMethods.setValue("dirtyFields.juchusu", fields.juchusu ?? "");
    meiMethods.setValue("dirtyFields.jodaitanka", fields.jodaitanka ?? "");
    meiMethods.setValue("dirtyFields.juchutanka", fields.juchutanka ?? "");
    meiMethods.setValue("dirtyFields.kakeritsu", fields.kakeritsu ?? "");
  };

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  const location = useLocation();
  const inputData = location.state as B010010InputData;
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 受注区分変更時の確認ダイアログオープン用
  const [openJuchuKbnConfirm, setJuchuKbnOpenConfirm] = useState(false);
  // 登録ボタンクリック時に出す確認ダイアログオープン用
  const [openCreateConfirm, setOpenCreateConfirm] = useState(false);
  // 更新ボタンクリック時に出す確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);

  // 再レンダリング用フラグ
  const [reRender, setReRender] = useState(false);
  const reRendering = () => {
    resetDirtyFields();
    resetMeiDirtyFields();
    setReRender(!reRender);
  };

  // 活性設定
  // 参照モードかどうか
  const isReference = () => methods.getValues().editKbn === editKbn.reference;
  // 編集モードかどうか
  const isUpdate = () => methods.getValues().editKbn === editKbn.update;
  // 受注区分が「1：見込品生産」かどうか
  const isMikomiSeisanhin = () =>
    methods.getValues().juchuKbn?.value === juchuKbn.expected;
  // 得意先.諸口が「1：諸口」かどうか
  const isNonyuShokuchi = () =>
    methods.getValues().nonyuShokuchiKbn === shokuchiKbn.shokuchi;
  // 添付伝票の入力可否(伝票種別が未入力時、入力不可)
  const isTenpudenpyoCdDisabled = () =>
    methods.getValues().denpyoshubetsuCd === "";
  // ベース上代単価、上代単価が一致するかどうか(手入力上代区分)
  const isTenyuryokujodaiKbn = () =>
    Number(meiMethods.getValues().basejodaitanka) ===
    Number(meiMethods.getValues().jodaitanka);
  // ベース下代単価、下代単価が一致するかどうか(手入力受注区分)
  const isTenyuryokujuchuKbn = () =>
    Number(meiMethods.getValues().basejuchutanka) ===
    Number(meiMethods.getValues().juchutanka);
  // 明細入力部への入力可否(有効な得意先が入力済(諸口区分が取得済)、かつ消費税率が取得済の場合、入力可能)
  const isMeiDisabled = () =>
    typeof methods.getValues().tokuiShokuchiKbn === "undefined" ||
    methods.getValues().zeiRitsu === "";
  // 商品.商品種別区分が「4:受注生産品」かどうか
  const isMeiJuchuSeisanhin = () =>
    meiMethods.getValues().shohinshubetsuKbn === shohinshubetsuKbn.madeToOrder;
  // 商品.諸口区分が「1:諸口」かどうか
  const isShohinShokuchiKbn = () =>
    meiMethods.getValues().shokuchiKbn === shohinShokuchiKbn.shokuchi;
  // 商品.セット商品区分が「1:セット品」かどうか
  const isSetshohinKbn = () =>
    meiMethods.getValues().setshohinKbn === setshohinKbn.set;
  const isKoseiDisabled = () => isMeiDisabled() || !isSetshohinKbn();
  // 明細入力部の金額の入力可否(受注数が入力済、かつ下代が入力済の場合、入力不可)
  const isKingakuDisabled = () =>
    meiMethods.getValues().juchusu !== "" &&
    meiMethods.getValues().juchutanka !== "";

  // 初期表示(編集・参照時の設定)
  useEffect(() => {
    // unregisterを使用する値をresetで初期化(defalutValueが無視され、初期値にundifindが設定されることがあるため)
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      tokuiCd: "",
      tokuishitenCd: "",
      nonyuCd: "",
      nonyushitenCd: "",
    });
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    if (inputData === null) {
      return;
    }
    // 編集区分の設定
    methods.setValue("editKbn", inputData.editKbn);

    // 入力プロパティの反映
    const juchu = inputData.juchu;
    if (typeof juchu === "undefined") return;
    // 受注データ設定
    methods.setValue("juchuKbn", getSCode(JuchuKbn, juchu.juchuKbn));
    methods.setValue("juchudenpyoNo", juchu.juchudenpyoNo ?? "");
    methods.setValue("juchuYmd", juchu.juchuYmd ?? "");
    methods.setValue("nohinyoteiYmd", juchu.nohinyoteiYmd ?? "");
    methods.setValue("tokuiShokuchiKbn", Number(juchu.tokuiShokuchiKbn));
    methods.setValue("tokuiCd", juchu.tokuiCd ?? "");
    methods.setValue("tokuishitenCd", juchu.tokuishitenCd ?? "");
    methods.setValue("tokuiNm", juchu.tokuiNm ?? "");
    methods.setValue("tankaKakeritsu", juchu.tankaKakeritsu ?? "");
    methods.setValue("zeimarumeKbn", Number(juchu.zeimarumeKbn));
    methods.setValue("kinmarumeKbn", Number(juchu.kinmarumeKbn));
    methods.setValue("tokuiPostCd", juchu.tokuiPostCd ?? "");
    methods.setValue("tokuiAddress1", juchu.tokuiAddress1 ?? "");
    methods.setValue("tokuiAddress2", juchu.tokuiAddress2 ?? "");
    methods.setValue("tokuiTelNo", juchu.tokuiTelNo ?? "");
    methods.setValue("tokuiFaxNo", juchu.tokuiFaxNo ?? "");
    methods.setValue("nonyuShokuchiKbn", Number(juchu.nonyuShokuchiKbn));
    methods.setValue("nonyuCd", juchu.nonyuCd ?? "");
    methods.setValue("nonyushitenCd", juchu.nonyushitenCd ?? "");
    methods.setValue("nonyuNm", juchu.nonyuNm ?? "");
    methods.setValue("nonyuPostCd", juchu.nonyuPostCd ?? "");
    methods.setValue("nonyuAddress1", juchu.nonyuAddress1 ?? "");
    methods.setValue("nonyuAddress2", juchu.nonyuAddress2 ?? "");
    methods.setValue("nonyuTelNo", juchu.nonyuTelNo ?? "");
    methods.setValue("nonyuFaxNo", juchu.nonyuFaxNo ?? "");
    methods.setValue("ediMemo", juchu.ediMemo ?? "");
    methods.setValue("shainCd", juchu.shainCd ?? "");
    methods.setValue("shainNm", juchu.shainNm ?? "");
    methods.setValue("eigyoCd", juchu.eigyoCd ?? "");
    methods.setValue("seisakuYmd", juchu.seisakuYmd ?? "");
    methods.setValue("shukayoteiYmd", juchu.shukayoteiYmd ?? "");
    methods.setValue("jisanYmd", juchu.jisanYmd ?? "");
    methods.setValue("denpyoYmd", juchu.denpyoYmd ?? "");
    methods.setValue("shimeD", juchu.shimeD ?? "");
    methods.setValue("chohaKbn", getSCode(ChohaKbn, juchu.chohaKbn));
    methods.setValue("hasosakiCd", getSCode(HasosakiCd, juchu.hasosakiCd));
    methods.setValue("hasokbnCd", getSCode(HasokbnCd, juchu.hasokbnCd));
    methods.setValue("zeiKbnView", getSCode(ZeiKbn, juchu.zeiKbn));
    methods.setValue("zeiKbn", juchu.zeiKbn ?? "");
    methods.setValue("assistantCd", juchu.assistantCd ?? "");
    methods.setValue("assistantNm", juchu.assistantNm ?? "");
    methods.setValue("denpyoshubetsuCd", juchu.denpyoshubetsuCd ?? "");
    methods.setValue("denpyoshubetsuNm", juchu.denpyoshubetsuNm ?? "");
    methods.setValue("tenpudenpyoCd", juchu.tenpudenpyoCd ?? "");
    methods.setValue("tenpudenpyoNm", juchu.tenpudenpyoNm ?? "");
    methods.setValue("bunrui", juchu.bunrui ?? "");
    methods.setValue("unsogaishaCd", juchu.unsogaishaCd ?? "");
    methods.setValue("unsogaishaNm", juchu.unsogaishaNm ?? "");
    methods.setValue("bumonCd", juchu.bumonCd ?? "");
    methods.setValue("bumonNm", juchu.bumonNm ?? "");
    methods.setValue("ppgakeKbn", getSCode(PpgakeKbn, juchu.ppgakeKbn));
    methods.setValue("netsukeKbn", getSCode(NetsukeKbn, juchu.netsukeKbn));
    methods.setValue("chumonNo", juchu.chumonNo ?? "");
    methods.setValue("denpyoKbn", juchu.denpyoKbn ?? "");
    methods.setValue("ritsu", juchu.ritsu ?? "");
    methods.setValue("hinbetsuNo", juchu.hinbetsuNo ?? "");
    methods.setValue("tantosha", juchu.tantosha ?? "");
    methods.setValue("bikoCd", juchu.bikoCd ?? "");
    methods.setValue("biko", juchu.biko ?? "");
    methods.setValue("bikoCdBefore", juchu.bikoCd ?? "");
    methods.setValue("nohinsaki", juchu.nohinsaki ?? "");
    methods.setValue("lineCd", juchu.lineCd ?? "");
    methods.setValue("lineNm", juchu.lineNm ?? "");
    methods.setValue("uribaNm", juchu.uribaNm ?? "");
    methods.setValue("naisen", juchu.naisen ?? "");
    methods.setValue("edijuchuNo", juchu.ediJuchuNo ?? "");
    methods.setValue("version", juchu.version ?? "");
    methods.setValue("zeiRitsu", juchu.zeiRitsu ?? "");
    methods.setValue("jodaihyojiKbn", juchu.jodaihyojiKbn ?? "");
    methods.setValue("tankamarumeKbn", juchu.tankamarumeKbn ?? "");
    methods.setValue("tankahasuichi", juchu.tankahasuichi ?? "");

    // 明細テーブル設定
    if (juchu.b010020GetMeiResponse === null) return;

    // カラム「受注生産品」を設定するため、商品種別のチェック結果を配列に保持
    const juchuSeisanhinKbnList: string[] = juchu.b010020GetMeiResponse.map(
      (value) => {
        let isJuchuSeisanhinKbn = "";

        // 受注生産品を含む場合
        if (Number(value.shohinshubetsuKbn) === shohinshubetsuKbn.madeToOrder) {
          isJuchuSeisanhinKbn = juchuSeisanhinKbn.ari;
        }
        // 受注生産品を含まない場合
        else {
          isJuchuSeisanhinKbn = juchuSeisanhinKbn.nashi;
        }

        return isJuchuSeisanhinKbn;
      }
    );

    const juchuMei = juchu.b010020GetMeiResponse.map<Data>((value, i) => {
      // 移行データは受注行番号が連番ではない可能性があるため振り直しを行う
      const juchugyoNo: number = i + 1;

      // ベース単価の算出
      let basejodaitanka: string;
      let basejuchutanka: string;
      // セット商品の場合
      if (Number(value.setshohinKbn) === setshohinKbn.set) {
        // 上代単価
        basejodaitanka = value.setJodaitanka;
        // 下代単価
        basejuchutanka = getJuchutanka(
          methods,
          basejodaitanka,
          value.kakeritsu
        );
      }
      // セット商品以外の場合
      else {
        // 単価区分「0:通常単価」の場合
        if (Number(value.tankaKbn) === tankaKbn.tujo) {
          // 取引先別単価マスタ.上代単価が取得できた場合
          if (value.toritankaJodaitanka !== null) {
            // 上代単価
            basejodaitanka = getJodaitanka(methods, value.toritankaJodaitanka);
            // 下代単価
            basejuchutanka = getUchizeiJuchutanka(
              methods,
              value.toritankaTanka
            );
          }
          // 取得できなかった場合
          else {
            // 上代単価
            basejodaitanka = getJodaitanka(methods, value.tankaTanka);
            // 下代単価
            basejuchutanka = getJuchutanka(
              methods,
              basejodaitanka,
              value.kakeritsu
            );
          }
        }
        // 単価区分「1:WH単価」の場合
        else {
          // 上代単価
          basejodaitanka = value.whJodaitanka;
          // 下代単価
          basejuchutanka = getJuchutanka(
            methods,
            basejodaitanka,
            value.kakeritsu
          );
        }
      }

      // 前回分の受注数、材料引当数の設定
      let meiShohinCdBefore: string = "";
      let meiJuchusuBefore: string = "";
      let meiZairyohikiatesuBefore: string = "";

      // 編集時の場合(複写時は設定しない)
      if (
        typeof juchu.juchudenpyoNo !== "undefined" &&
        juchu.juchudenpyoNo !== null
      ) {
        // 可能数が設定されている場合(受注生産品かつ材料商品なしの場合、可能数は設定されない)
        if (typeof value.kanosu !== "undefined" && value.kanosu !== null) {
          meiShohinCdBefore = value.shohinCd;
          meiJuchusuBefore = value.juchusu;
          meiZairyohikiatesuBefore = value.zairyohikiatesu;
        }
      }

      const mei: Data = {
        juchugyoNo,
        uchiwakeKbnView: getSCode(JuchuUchiwakeKbn, value.uchiwakeKbn)?.label,
        uchiwakeKbn: value.uchiwakeKbn ?? "",
        juchuSeisanhinKbnView: getSCode(
          JuchuSeisanhinKbn,
          juchuSeisanhinKbnList[i]
        )?.label,
        juchuSeisanhinKbn: juchuSeisanhinKbnList[i],
        shohinCd: value.shohinCd ?? "",
        shohinCdBefore: meiShohinCdBefore,
        janCd: value.janCd ?? "",
        shohinNm: value.shohinNm ?? "",
        edishohinNm: value.edishohinNm ?? "",
        aiteCd: value.aiteCd ?? "",
        sokoCd: value.sokoCd ?? "",
        sokoNm: value.sokoNm ?? "",
        vol: value.vol ?? "",
        sotosunW: value.sotosunW ?? "",
        sotosunH: value.sotosunH ?? "",
        uchisunW: value.uchisunW ?? "",
        uchisunH: value.uchisunH ?? "",
        juchusu: value.juchusu ?? "",
        juchusuBefore: meiJuchusuBefore,
        kanosu: value.kanosu ?? "",
        tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
        tenyuryokujuchuKbn: Number(value.tenyuryokujuchuKbn),
        basejodaitanka,
        basejuchutanka,
        jodaitanka: value.jodaitanka ?? "",
        juchutanka: value.juchutanka ?? "",
        kakeritsu: value.kakeritsu ?? "",
        juchuKin: value.juchuKin ?? "",
        meisaibikoCd: value.meisaibikoCd ?? "",
        meisaibiko: value.meisaibiko ?? "",
        kazeiKbn: Number(value.kazeiKbn),
        setshohinKbn: Number(value.setshohinKbn),
        shohinshubetsuKbn: Number(value.shohinshubetsuKbn),
        tankaKbn: Number(value.tankaKbn),
        shokuchiKbn: Number(value.shokuchiKbn),
        whtankaCd: value.whtankaCd ?? "",
        sokoshubetsuKbn: Number(value.sokoshubetsuKbn),
        zairyohikiatesuBefore: meiZairyohikiatesuBefore,
        zairyohikiateKanoNagasa: value.zairyohikiateKanoNagasa,
        zairyohikiateNagasa: value.zairyohikiateNagasa,
        crtshainCd: value.crtshainCd ?? "",
        crtDate: value.crtDate ?? "",
        koseiData: [],
      };
      // 構成データ設定
      if (value.b010020GetMeiKoseiResponse === null) {
        return mei;
      }
      mei.koseiData = value.b010020GetMeiKoseiResponse.map<KoseiData>(
        (value, i) => {
          // 移行データは受注行番号が連番ではない可能性があるため振り直しを行う
          const juchukoseigyoNo: number = i + 1;

          // ベース単価の算出
          let setBasejodaitanka: string;
          let setBasejuchutanka: string;

          // セット商品マスタ.上代単価が取得できた場合
          if (value.setJodaitanka !== null) {
            // 上代単価
            setBasejodaitanka = value.setJodaitanka;
            // 下代単価
            setBasejuchutanka = getJuchutanka(
              methods,
              setBasejodaitanka,
              value.kakeritsu
            );
          }
          // セット商品マスタ.上代単価が取得できなかった場合
          else {
            // 単価区分「0:通常単価」の場合
            if (Number(value.tankaKbn) === tankaKbn.tujo) {
              // 取引先別単価マスタ.上代単価が取得できた場合
              if (value.toritankaJodaitanka !== null) {
                // 上代単価
                setBasejodaitanka = getJodaitanka(
                  methods,
                  value.toritankaJodaitanka
                );
                // 下代単価
                setBasejuchutanka = getUchizeiJuchutanka(
                  methods,
                  value.toritankaTanka
                );
              }
              // 取得できなかった場合
              else {
                // 上代単価
                setBasejodaitanka = getJodaitanka(methods, value.tankaTanka);
                // 下代単価
                setBasejuchutanka = getJuchutanka(
                  methods,
                  setBasejodaitanka,
                  value.kakeritsu
                );
              }
            }
            // 単価区分「1:WH単価」の場合
            else {
              // 上代単価
              setBasejodaitanka = value.whJodaitanka;
              // 下代単価
              setBasejuchutanka = getJuchutanka(
                methods,
                setBasejodaitanka,
                value.kakeritsu
              );
            }
          }

          // 前回分の必要数の設定
          let meiKoseiShohinCdBefore: string = "";
          let meiKoseiHitsuyosuBefore: string = "";
          let meiKoseiZairyohikiatesuBefore: string = "";
          // 編集時の場合(複写時は設定しない)
          if (
            typeof juchu.juchudenpyoNo !== "undefined" &&
            juchu.juchudenpyoNo !== null
          ) {
            // 可能数が設定されている場合(受注生産品かつ材料商品なしの場合、可能数は設定されない)
            if (typeof value.kanosu !== "undefined" && value.kanosu !== null) {
              meiKoseiShohinCdBefore = value.shohinCd;
              meiKoseiHitsuyosuBefore = value.hitsuyosu;
              meiKoseiZairyohikiatesuBefore = value.zairyohikiatesu;
            }
          }

          const meiKosei: KoseiData = {
            juchugyoNo,
            juchukoseigyoNo,
            shohinCd: value.shohinCd ?? "",
            shohinCdBefore: meiKoseiShohinCdBefore,
            janCd: value.janCd ?? "",
            shohinNm: value.shohinNm ?? "",
            aiteCd: value.aiteCd ?? "",
            sokoCd: value.sokoCd ?? "",
            sokoNm: value.sokoNm ?? "",
            vol: value.vol ?? "",
            sotosunW: value.sotosunW ?? "",
            sotosunH: value.sotosunH ?? "",
            uchisunW: value.uchisunW ?? "",
            uchisunH: value.uchisunH ?? "",
            hitsuyosu: value.hitsuyosu ?? "",
            hitsuyosuBefore: meiKoseiHitsuyosuBefore,
            koseisu: value.koseisu ?? "",
            kanosu: value.kanosu ?? "",
            tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
            tenyuryokujuchuKbn: Number(value.tenyuryokujuchuKbn),
            basejodaitanka: setBasejodaitanka,
            basejuchutanka: setBasejuchutanka,
            jodaitanka: value.jodaitanka ?? "",
            juchutanka: value.juchutanka ?? "",
            kakeritsu: value.kakeritsu ?? "",
            juchuKin: value.juchuKin ?? "",
            meisaikoseiBikoCd: value.meisaikoseiBikoCd ?? "",
            meisaikoseiBiko: value.meisaikoseiBiko ?? "",
            kazeiKbn: Number(value.kazeiKbn),
            shohinshubetsuKbn: Number(value.shohinshubetsuKbn),
            tankaKbn: Number(value.tankaKbn),
            shokuchiKbn: Number(value.shokuchiKbn),
            whtankaCd: value.whtankaCd ?? "",
            sokoshubetsuKbn: Number(value.sokoshubetsuKbn),
            zairyohikiatesuBefore: meiKoseiZairyohikiatesuBefore,
            zairyohikiateKanoNagasa: value.zairyohikiateKanoNagasa,
            zairyohikiateNagasa: value.zairyohikiateNagasa,
            crtDate: value.crtDate ?? "",
            crtshainCd: value.crtshainCd ?? "",
          };
          return meiKosei;
        }
      );
      return mei;
    });
    // テーブルに反映
    setRows(juchuMei);
    reRendering();
  }, []);

  // 初期表示(共通)
  useEffect(() => {
    (async () => {
      // 消費税取得
      await B010010ZeiRitsu(methods);
      // フォーカス
      switch (methods.watch("editKbn")) {
        case editKbn.register:
          focus(1);
          break;
        case editKbn.update:
          focus(2);
          break;
      }
    })();
  }, []);

  // 明細変更
  useEffect(() => {
    //合計金額算出
    handleGokeiCalculating();
    reRendering();
  }, [rows]);

  // 受注区分変更確認ダイアログ表示
  const handleOpenConfirm = () => {
    setJuchuKbnOpenConfirm(true);
  };

  //受注区分変更キャンセル
  const handleCancelConfirm = () => {
    setJuchuKbnOpenConfirm(false);

    // フォームのデータを取得する。
    const fields = methods.getValues();
    // 区分の変更を戻す
    const prevJuchuKbn =
      fields.juchuKbn?.value === juchuKbn.normal
        ? juchuKbn.expected
        : juchuKbn.normal;

    // 受注区分を再設定
    methods.setValue("juchuKbn", getSCode(JuchuKbn, prevJuchuKbn));
    reRendering();
  };

  // 発送日変更時(カレンダー選択時にshukayoteiYmdを受け取る)
  const handleChangeShukayoteiYmd = (
    shukayoteiYmd: string | null | undefined = methods.getValues().shukayoteiYmd
  ) => {
    // 未入力OR不正な値の場合、何もしない
    if (!shukayoteiYmd || shukayoteiYmd === "" || !validDate(shukayoteiYmd!))
      return;

    // 伝票日付の変更処理を呼び出す
    handleChangeDenpyoYmd();
    methods.setValue("denpyoYmd", shukayoteiYmd);
    reRendering();
  };

  // 伝票日付変更時(カレンダー選択時にdenpyoYmdを受け取る)
  const handleChangeDenpyoYmd = (
    denpyoYmd: string | null | undefined = methods.getValues().denpyoYmd
  ) => {
    if (denpyoYmd === methods.getValues().dirtyFields?.denpyoYmd) return;
    // 未入力OR不正な値の場合、何もしない
    if (!denpyoYmd || denpyoYmd === "" || !validDate(denpyoYmd!)) {
      methods.setValue("zeiRitsu", "");

      reRendering();
      return;
    }

    (async () => {
      // 消費税取得
      await B010010ZeiRitsu(methods);

      // 明細入力部の単価再設定
      await reacquisitionMeiTanka();

      // 明細が登録されている場合
      if (rows.length > 0) {
        // 明細再設定
        // 上代単価、下代単価が変更されていない商品コードを取得(重複排除)
        const shohinCdList: string[] = Array.from(
          new Set(
            rows
              // 手入力区分をチェック
              .filter(
                (row) => row.tenyuryokujodaiKbn === tenyuryokujodaiKbn.none
              )
              .filter(
                (row) => row.tenyuryokujuchuKbn === tenyuryokujuchuKbn.none
              )
              // セット商品区分をチェック
              .filter((row) => row.setshohinKbn === setshohinKbn.single)
              // 単価区分をチェック
              .filter((row) => row.tankaKbn === tankaKbn.tujo)
              .map((row) => row.shohinCd!)
          )
        );

        // 再設定する行が存在する場合
        if (shohinCdList.length > 0) {
          // 単価マスタより再取得を行う
          await B010010TankaList(
            methods,
            shohinCdList,
            rows,
            setRows,
            navigate,
            setMsg
          );
        }
        // 再設定する行が存在しない場合
        else {
          // 合計値(rowsに変更が無いため、明示的に処理を呼ぶ)
          handleGokeiCalculating();
        }
      }
      reRendering();
    })();
  };

  // 明細入力部の単価再設定
  const reacquisitionMeiTanka = async () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    // 明細入力部が設定されていない場合(商品種別区分で判断)
    if (meiFields.shohinshubetsuKbn === undefined) return;

    // 手入力上代区分が「1:あり」の場合
    if (meiFields.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) return;

    // 手入力受注区分が「1:あり」の場合
    if (meiFields.tenyuryokujuchuKbn === tenyuryokujuchuKbn.exists) return;

    // セット商品区分が「1:セット品」の場合
    if (meiFields.setshohinKbn === setshohinKbn.set) return;

    // 単価区分が「1:WH単価」の場合
    if (meiFields.tankaKbn === tankaKbn.wh) return;

    // 単価再取得処理を行う
    await B010010Tanka(methods, meiMethods, navigate, setMsg);
    reRendering();
  };

  // 受注区分切替
  const handleChangeJuchuKbn = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 初期化
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      tokuiCd: "",
      tokuishitenCd: "",
      nonyuCd: "",
      nonyushitenCd: "",
    });
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });
    setRows([]);

    // 通常受注 → 見込品生産へ切り替え
    if (fields.juchuKbn?.value === "1") {
      // 全てクリアされるので、受注区分を再設定
      methods.setValue("juchuKbn", getSCode(JuchuKbn, "1"));

      // 固定値の設定
      methods.setValue("tokuiCd", tokuiCd);
      methods.setValue("tokuishitenCd", tokuishitenCd);
      // 得意先変更
      (async () => {
        // 得意先関連項目設定
        await B010010Tokui(methods, navigate, setMsg);
        // 消費税取得
        await B010010ZeiRitsu(methods);
        // 消費税取得
        await B010010ZeiRitsu(methods);
        setJuchuKbnOpenConfirm(false);
        reRendering();
      })();
    } else {
      (async () => {
        // 消費税取得
        await B010010ZeiRitsu(methods);

        setJuchuKbnOpenConfirm(false);
        reRendering();
      })();
    }
  };

  // 得意先変更(得意先コード、得意先支店コード)
  const handleChangeTokui = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    if (
      fields.tokuiCd === fields.dirtyFields?.tokuiCd &&
      fields.tokuishitenCd === fields.dirtyFields?.tokuishitenCd
    ) {
      return;
    }

    if (fields.tokuiCd === "" || fields.tokuishitenCd === "") {
      methods.setValue("tokuiShokuchiKbn", undefined);
      methods.setValue("tokuiNm", "");
      methods.setValue("tokuiPostCd", "");
      methods.setValue("tokuiAddress1", "");
      methods.setValue("tokuiAddress2", "");
      methods.setValue("tokuiTelNo", "");
      methods.setValue("tokuiFaxNo", "");
      methods.setValue("shainCd", "");
      methods.setValue("bumonCd", "");
      methods.setValue("shimeD", "");
      methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
      methods.setValue("zeiKbn", "");
      methods.setValue("zeimarumeKbn", undefined);
      methods.setValue("jodaihyojiKbn", "");
      methods.setValue("kinmarumeKbn", undefined);
      methods.setValue("tankamarumeKbn", "");
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      reRendering();
      return;
    }

    // 得意先関連項目設定
    (async () => {
      await B010010Tokui(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 納入先変更(得意先コード、得意先支店コード)
  const handleChangeNonyu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    if (
      fields.nonyuCd === fields.dirtyFields?.nonyuCd &&
      fields.nonyushitenCd === fields.dirtyFields?.nonyushitenCd
    ) {
      return;
    }
    if (fields.nonyuCd === "" || fields.nonyushitenCd === "") {
      methods.setValue("nonyuShokuchiKbn", undefined);
      methods.setValue("nonyuNm", "");
      methods.setValue("nonyuPostCd", "");
      methods.setValue("nonyuAddress1", "");
      methods.setValue("nonyuAddress2", "");
      methods.setValue("nonyuTelNo", "");
      methods.setValue("nonyuFaxNo", "");
      reRendering();
      return;
    }

    // 納入先関連項目設定
    (async () => {
      await B010010Nonyu(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 下代、受注金額設定
  const handleCalcJuchutankaJuchuKin = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    if (
      meiFields.kakeritsu === meiFields.dirtyFields?.kakeritsu &&
      meiFields.jodaitanka === meiFields.dirtyFields?.jodaitanka
    ) {
      return;
    }

    // 上代単価、掛率が未入力の場合
    if (meiFields.jodaitanka === "") {
      return;
    }
    if (meiFields.kakeritsu === "") {
      return;
    }

    // 手入力受注区分が「1:有り」の場合
    if (!isTenyuryokujuchuKbn()) {
      return;
    }

    // 下代単価取得
    const juchutanka: string = getJuchutanka(
      methods,
      meiFields.jodaitanka!,
      meiFields.kakeritsu!
    );
    // 下代単価
    meiMethods.setValue("juchutanka", juchutanka);
    // ベース下代単価
    meiMethods.setValue("basejuchutanka", juchutanka);

    // 受注金額
    handleCalcJuchuKin();
    reRendering();
  };

  // 下代入力時設定
  const handleCalcJuchuKinFromJuchutanka = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    if (meiFields.juchutanka === meiFields.dirtyFields?.juchutanka) {
      return;
    }
    handleCalcJuchuKin();
    reRendering();
  };

  // 受注金額設定
  const handleCalcJuchuKin = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 受注金額
    meiMethods.setValue(
      "juchuKin",
      getJuchuKin(
        meiFields.juchutanka!,
        meiFields.juchusu!,
        fields.kinmarumeKbn!
      )
    );
  };

  // 受注数変更
  const handleChangeJuchusu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    if (
      meiFields.juchusu === meiFields.dirtyFields?.juchusu &&
      meiFields.juchutanka === meiFields.dirtyFields?.juchutanka
    ) {
      return;
    }

    // セット構成品が存在する場合
    if (meiFields.koseiData && Object.keys(meiFields.koseiData).length !== 0) {
      // 構成品データの更新
      const newRows = meiFields.koseiData?.map((koseiRow: KoseiData) => {
        // 必要数
        koseiRow.hitsuyosu = getHitsuyosu(
          koseiRow.koseisu!,
          meiFields.juchusu!
        );

        // 構成品.受注金額
        koseiRow.juchuKin = getJuchuKin(
          koseiRow.juchutanka!,
          koseiRow.hitsuyosu!,
          fields.kinmarumeKbn!
        );
        reRendering();
        return koseiRow;
      });
      meiMethods.setValue("koseiData", newRows);
      reRendering();
    }

    // 受注金額
    meiMethods.setValue(
      "juchuKin",
      getJuchuKin(
        meiFields.juchutanka!,
        meiFields.juchusu!,
        fields.kinmarumeKbn!
      )
    );
    reRendering();
  };

  // 受注担当者変更
  const handleChangeShain = () => {
    const fields = methods.getValues();
    if (fields.shainCd === fields.dirtyFields?.shainCd) {
      return;
    }
    (async () => {
      await B000140Shain(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 伝票種別変更
  const handleChangeDenpyoshubetsu = () => {
    const fields = methods.getValues();
    if (fields.denpyoshubetsuCd === fields.dirtyFields?.denpyoshubetsuCd) {
      return;
    }

    (async () => {
      await B000111DenpyoshubetsuNmAndTenpudenpyo(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 添付伝票変更
  const handleChangeTenpudenpyo = () => {
    const fields = methods.getValues();
    if (fields.tenpudenpyoCd === fields.dirtyFields?.tenpudenpyoCd) {
      return;
    }

    (async () => {
      await B000111TenpudenpyoNmByDenpyoshubetsu(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 運送会社変更
  const handleChangeUnsogaisha = () => {
    const fields = methods.getValues();
    if (fields.unsogaishaCd === fields.dirtyFields?.unsogaishaCd) {
      return;
    }

    (async () => {
      await B000111UnsogaishaNm(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // アシスタント変更
  const handleChangeAssistant = () => {
    const fields = methods.getValues();
    if (fields.assistantCd === fields.dirtyFields?.assistantCd) {
      return;
    }

    (async () => {
      await B000140AssistantNm(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // ラインNo.変更
  const handleChangeLine = () => {
    (async () => {
      await B000111LineNm(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 明細備考変更
  const handleChangeBiko = () => {
    (async () => {
      await B000111Biko(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 商品コード変更
  const handleChangeShohinCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.shohinCd === meiFields.dirtyFields?.shohinCd) return;
      await B010010HandleChangeShohinCd(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // Janコード変更
  const handleChangeJanCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.janCd === meiFields.dirtyFields?.janCd) return;
      await B010010HandleChangeJanCd(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // 倉庫コード変更
  const handleChangeSokoCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.sokoCd === meiFields.dirtyFields?.sokoCd) return;
      // 倉庫名表示
      await B000190SokoNmSokoshubetsuKbn(meiMethods, navigate, setMsg);
      // 引当可能数変更処理
      await B010010Kanosu(meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // WH単価変更
  const handleChangeWhTanka = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (
        meiFields.sotosunW === meiFields.dirtyFields?.sotosunW &&
        meiFields.sotosunH === meiFields.dirtyFields?.sotosunH
      ) {
        return;
      }
      await B010010WhTanka(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // タブ切替
  const handleChangeMeiTab = () => {
    if (!meiMethods.watch("meiTab")) return;
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });
    meiMethods.setValue("meiTab", true);
    reRendering();
  };

  //  ダイアログ表示用（登録）
  const handleOpenCreateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenCreateConfirm(true);
    } else {
      handleClickCreateButton();
    }
  };

  //  ダイアログ表示用（更新）
  const handleOpenUpdateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenUpdateConfirm(true);
    } else {
      handleClickUpdateButton();
    }
  };

  // キャンセル押下時（登録）
  const handleCancelCreateConfirm = () => {
    setOpenCreateConfirm(false);
  };
  // キャンセル押下時（更新）
  const handleCancelUpdateConfirm = () => {
    setOpenUpdateConfirm(false);
  };

  // 登録
  const handleClickCreateButton = () => {
    setOpenCreateConfirm(false);

    // フィールドチェック
    B010010Create(methods, rows)
      .then((response) => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          tokuiCd: "",
          tokuishitenCd: "",
          nonyuCd: "",
          nonyushitenCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });
        setRows([]);

        (async () => {
          // 消費税取得
          await B010010ZeiRitsu(methods);
          setMsg(getClientMessage("B010010_001", response.data.juchudenpyoNo));
          reRendering();
        })();
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg, B010010CreateRequestFieldName);
      });
  };

  // 更新
  const handleClickUpdateButton = () => {
    setOpenUpdateConfirm(false);

    // フィールドチェック
    B010010Update(methods, rows)
      .then(() => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          tokuiCd: "",
          tokuishitenCd: "",
          nonyuCd: "",
          nonyushitenCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });
        setRows([]);

        (async () => {
          // 消費税取得
          await B010010ZeiRitsu(methods);
          setMsg(getClientMessage("B010010_002"));
          reRendering();
        })();
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 明細登録
  const handleClickCreateMeiButton = () => {
    // 独自チェック
    if (invalidated()) {
      return;
    }

    // フィールドチェック
    meiMethods.handleSubmit(
      () => {
        // 明細に設定するデータを取得
        const juchugyoNo: number = rows.length + 1;
        const data: Data = handleDataMapping(juchugyoNo);

        // 明細を設定
        setRows([...rows, data]);
        setRowCount(juchugyoNo);

        // 行選択の解除
        setRowData(undefined);

        // 明細クリア
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });

        focus(36);
        reRendering();
      },
      () => {
        focus(36);
        reRendering();
      }
    )();
  };

  // 明細更新
  const handleClickUpdateMeiButton = () => {
    // 独自チェック
    if (invalidated()) {
      return;
    }

    // TODO: react-formのエラーチェック
    // フィールドチェック
    meiMethods.handleSubmit(
      () => {
        const juchugyoNo: number = rowData?.juchugyoNo!;
        // 明細に設定するデータを取得
        const data: Data = handleDataMapping(juchugyoNo);
        // 明細を設定
        rows[juchugyoNo - 1] = data;
        setRows([...rows]);

        // 行選択の解除
        setRowData(undefined);

        // 明細クリア
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });

        // 明細入力部を新規登録に変更する
        meiMethods.setValue("meiTab", true);

        focus(36);
        reRendering();
      },
      () => {
        focus(36);
        reRendering();
      }
    )();
  };

  // 独自チェック
  const invalidated = (): boolean => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 行番号
    const juchugyoNo: number = rowData?.juchugyoNo ?? rows.length + 1;

    // 受注数が0以下の場合
    if (Number(meiFields.juchusu) <= juchusuMin) {
      setMsg(getClientError("B010010_001"));
      focus(45);
      return true;
    }

    // 掛率が0～999以外の場合
    if (
      !(
        Number(meiFields.kakeritsu) >= KakerituRangeMin &&
        Number(meiFields.kakeritsu) <= KakerituRangeMax
      )
    ) {
      setMsg(getClientError("B010010_002"));
      focus(47);
      return true;
    }

    // 受注金額が9桁より大きい場合
    if (meiFields.juchuKin!.length > juchuKinMaxLength) {
      setMsg(getClientError("B010010_003"));
      focus(49);
      return true;
    }

    // 上代合計・下代合計の金額が9桁より大きい場合エラー
    // 上代合計(現在編集中の行を除いた合計値を取得)
    const jodaitankaGokei: string = rows
      .filter(function (source: Data) {
        return Number(source.juchugyoNo) !== juchugyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.jodaitanka ? row.jodaitanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.jodaitanka ? meiFields.jodaitanka : "0"))
      .toString();
    // 受注金額が9桁より大きい場合
    if (jodaitankaGokei.length > jodaitankaMaxLength) {
      setMsg(getClientError("B010010_004"));
      focus(49);
      return true;
    }

    // 下代合計(現在編集中の行を除いた合計値を取得)
    const juchutankaGokei: string = rows
      .filter(function (source: Data) {
        return Number(source.juchugyoNo) !== juchugyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.juchutanka ? row.juchutanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.juchutanka ? meiFields.juchutanka : "0"))
      .toString();
    // 受注金額が9桁より大きい場合
    if (juchutankaGokei.length > juchutankaMaxLength) {
      setMsg(getClientError("B010010_005"));
      focus(49);
      return true;
    }

    // 商品種別区分が「9:材料品」の場合
    if (meiFields.shohinshubetsuKbn! === shohinshubetsuKbn.materials) {
      setMsg(getClientError("B010010_006"));
      focus(36);
      return true;
    }

    // 倉庫が物流倉庫、引当倉庫以外の場合
    if (
      !(
        meiFields.sokoshubetsuKbn === sokoshubetsuKbn.logicalSoko ||
        meiFields.sokoshubetsuKbn === sokoshubetsuKbn.hikiateSoko
      )
    ) {
      setMsg(getClientError("B010010_007"));
      focus(38);
      return true;
    }

    // 外寸の入力値チェック
    if (meiFields.sotosunH || meiFields.sotosunW) {
      // 外寸が片方だけ入力されている場合エラー
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B010010_008"));
        focus(41);
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B010010_009"));
        focus(42);
        return true;
      }
    }
    // 内寸の入力値チェック
    if (meiFields.uchisunH || meiFields.uchisunW) {
      // 内寸が片方だけ入力されている場合エラー
      if (!meiFields.uchisunW) {
        setMsg(getClientError("B010010_012"));
        focus(43);
        return true;
      }
      if (!meiFields.uchisunH) {
        setMsg(getClientError("B010010_013"));
        focus(44);
        return true;
      }
    }

    // WH単価の商品の場合
    if (meiFields.tankaKbn === tankaKbn.wh) {
      // 外寸が入っていない場合
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B010010_016"));
        focus(41);
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B010010_016"));
        focus(42);
        return true;
      }
      // 外寸が0以下の場合
      if (Number(meiFields.sotosunW) <= whMin) {
        setMsg(getClientError("B010010_010"));
        focus(41);
        return true;
      }
      if (Number(meiFields.sotosunH) <= whMin) {
        setMsg(getClientError("B010010_011"));
        focus(42);
        return true;
      }
    }

    // 可能数チェック(これ以降ではチェックを行わないこと)
    // 受注区分が「1:見込品生産」の場合
    if (fields.juchuKbn?.value === "1") {
      return false;
    }

    // 可能数が空の場合は引当可能かチェックしない(受注生産品かつ材料商品コードなしのため)
    if (meiFields.kanosu === null || meiFields.kanosu === "") {
      return false;
    }

    // 商品コードが前回分の明細.商品コードと同じ場合
    if (meiFields.shohinCd === meiFields.shohinCdBefore) {
      // セット品の場合
      if (meiFields.setshohinKbn === setshohinKbn.set) {
        // セット構成品が設定されている場合
        if (Object.keys(meiFields.koseiData!).length !== 0) {
          let isKoseiKanosuFusoku: boolean = false;

          for (const kosei of meiFields.koseiData!) {
            // 明細構成.商品コードが前回分の明細構成.商品コードと同じ場合
            if (kosei.shohinCd === kosei.shohinCdBefore) {
              // 通常単価の商品の場合
              if (kosei.tankaKbn === tankaKbn.tujo) {
                // 必要数 > 可能数 + 前回分の必要数の場合
                if (
                  Number(kosei.hitsuyosu) >
                  Number(kosei.hitsuyosu) + Number(kosei.hitsuyosuBefore)
                ) {
                  isKoseiKanosuFusoku = true;
                  break;
                }
              }
              // WH単価の商品の場合
              else {
                // 今回必要な長さを取得
                const hituyoNagasa: Big = new Big(
                  kosei.zairyohikiateNagasa ? kosei.zairyohikiateNagasa : "0"
                ).mul(new Big(kosei.hitsuyosu!));

                // 今回必要な長さ > 前回分を考慮した引当可能な長さ
                if (
                  Number(hituyoNagasa) > Number(kosei.zairyohikiateKanoNagasa)
                ) {
                  isKoseiKanosuFusoku = true;
                  break;
                }
              }
            }
          }
          // 引当可能かチェック
          if (isKoseiKanosuFusoku) {
            setMsg(getClientError("B010010_017"));
            focus(36);
            return true;
          }
        }
      }
      // セット品以外の場合
      else {
        // 通常単価の商品の場合
        if (meiFields.tankaKbn === tankaKbn.tujo) {
          // 受注数 > 可能数 + 前回分の受注数の場合
          if (
            Number(meiFields.juchusu) >
            Number(meiFields.kanosu) + Number(meiFields.juchusuBefore)
          ) {
            setMsg(getClientError("B010010_017"));
            focus(45);
            return true;
          }
        }
        // WH単価の商品の場合
        else {
          // 今回必要な長さを取得
          const hituyoNagasa: Big = new Big(
            meiFields.zairyohikiateNagasa ? meiFields.zairyohikiateNagasa : "0"
          ).mul(new Big(meiFields.juchusu!));

          // 今回必要な長さ > 前回分を考慮した引当可能な長さ
          if (
            Number(hituyoNagasa) > Number(meiFields.zairyohikiateKanoNagasa)
          ) {
            setMsg(getClientError("B010010_017"));
            focus(45);
            return true;
          }
        }
      }
    }
    // 商品コードが前回分の明細.商品コードと同じではない場合
    else {
      // 受注数 > 可能数の場合
      if (Number(meiFields.juchusu) > Number(meiFields.kanosu)) {
        setMsg(getClientError("B010010_017"));
        focus(36);
        return true;
      }
    }

    return false;
  };

  // 明細のデータマッピング
  const handleDataMapping = (juchugyoNo: number): Data => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    const data: Data = {
      juchugyoNo,
      uchiwakeKbnView: meiFields.uchiwakeKbn?.label,
      uchiwakeKbn: meiFields.uchiwakeKbn?.value,
      juchuSeisanhinKbnView: meiFields.juchuSeisanhinKbn?.label,
      juchuSeisanhinKbn: meiFields.juchuSeisanhinKbn?.value,
      shohinCd: meiFields.shohinCd,
      shohinCdBefore: meiFields.shohinCdBefore,
      janCd: meiFields.janCd,
      shohinNm: meiFields.shohinNm,
      edishohinNm: meiFields.edishohinNm,
      aiteCd: meiFields.aiteCd,
      sokoCd: meiFields.sokoCd,
      sokoNm: meiFields.sokoNm,
      vol: meiFields.vol,
      sotosunW: meiFields.sotosunW,
      sotosunH: meiFields.sotosunH,
      uchisunW: meiFields.uchisunW,
      uchisunH: meiFields.uchisunH,
      juchusu: meiFields.juchusu,
      juchusuBefore: meiFields.juchusuBefore,
      kanosu: meiFields.kanosu,
      // 手入力上代区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokujodaiKbn: isTenyuryokujodaiKbn()
        ? tenyuryokujodaiKbn.none
        : tenyuryokujodaiKbn.exists,
      // 手入力受注区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokujuchuKbn: isTenyuryokujuchuKbn()
        ? tenyuryokujuchuKbn.none
        : tenyuryokujuchuKbn.exists,
      basejodaitanka: meiFields.basejodaitanka,
      basejuchutanka: meiFields.basejuchutanka,
      jodaitanka: meiFields.jodaitanka,
      juchutanka: meiFields.juchutanka,
      kakeritsu: meiFields.kakeritsu,
      juchuKin: meiFields.juchuKin,
      meisaibikoCd: meiFields.meisaibikoCd,
      meisaibiko: meiFields.meisaibiko,
      kazeiKbn: meiFields.kazeiKbn,
      setshohinKbn: meiFields.setshohinKbn,
      shohinshubetsuKbn: meiFields.shohinshubetsuKbn,
      tankaKbn: meiFields.tankaKbn,
      shokuchiKbn: meiFields.shokuchiKbn,
      whtankaCd: meiFields.whtankaCd,
      sokoshubetsuKbn: meiFields.sokoshubetsuKbn,
      zairyohikiatesuBefore: meiFields.zairyohikiatesuBefore,
      zairyohikiateKanoNagasa: meiFields.zairyohikiateKanoNagasa,
      zairyohikiateNagasa: meiFields.zairyohikiateNagasa,
      crtshainCd: meiFields.crtshainCd,
      crtDate: meiFields.crtDate,
      koseiData: meiFields.koseiData?.map(
        // 構成データに受注行番号を設定
        (source: KoseiData) => {
          source.juchugyoNo = juchugyoNo;
          return source;
        }
      ),
    };

    return data;
  };

  // 明細削除
  const handleClickDeleteMeiButton = () => {
    // 選択行の取得
    if (typeof rowData?.juchugyoNo === "undefined") return;
    const juchugyoNo: number = rowData.juchugyoNo;
    // 対象の行を削除
    const newRows = rows
      .filter(function (source: Data) {
        return source.juchugyoNo !== juchugyoNo;
      })
      // 明細の連番の振り直し
      .map((meiRow: any, index) => {
        // 明細
        meiRow.juchugyoNo = ++index;
        // セット商品以外の場合
        if (meiRow.setshohinKbn === setshohinKbn.single) {
          // 何もしない
          return meiRow;
        }
        // セット構成品の受注行番号を再設定
        meiRow.koseiData.map((koseiRow: any) => {
          koseiRow.juchugyoNo = index;
          return koseiRow;
        });
        return meiRow;
      });

    setRows(newRows);

    // 行選択の解除
    setRowData(undefined);

    // 明細クリア
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    // 明細入力部を新規登録に変更する
    meiMethods.setValue("meiTab", true);
    reRendering();
  };

  //合計金額算出
  const handleGokeiCalculating = () => {
    // 明細が設定されていない場合
    if (rows.length === 0) {
      // 合計金額の初期化のみ行う
      methods.setValue("juchuKinGokei", "");
      methods.setValue("zeiGokei", "");
      methods.setValue("denpyoGokei", "");
      return;
    }

    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 受注金額合計
    const juchuKinGokei: Big = rows.reduce((acc: Big, row: Data): Big => {
      return acc.plus(new Big(row.juchuKin ? row.juchuKin : "0"));
    }, new Big("0"));

    // 消費税
    let zeiGokei: Big = new Big(0);
    // 消費税区分が「0」(外税/明細単位)の場合
    if (fields.zeiKbn === zeiKbn.sotozeiMei) {
      // 税丸め区分を取得
      let zeiRoundingMode: RoundingMode;
      // 四捨五入
      if (fields.zeimarumeKbn === zeimarumeKbn.shishagonyu) {
        zeiRoundingMode = Big.roundHalfUp;
      }
      //切り捨て
      else if (fields.zeimarumeKbn === zeimarumeKbn.kirisute) {
        zeiRoundingMode = Big.roundDown;
      }
      //切り上げ
      else if (fields.zeimarumeKbn === zeimarumeKbn.kiriage) {
        zeiRoundingMode = Big.roundUp;
      }

      // 消費税合計 ※小数点以下は得意先毎の丸め処理を行う
      zeiGokei = juchuKinGokei
        .times(new Big(fields.zeiRitsu ?? "0"))
        .div(new Big("100"))
        .round(0, zeiRoundingMode!);
    }
    // 消費税区分が「1」(外税/伝票単位)の場合
    if (fields.zeiKbn === zeiKbn.sotozeiDen) {
      // 税丸め区分を取得
      let zeiRoundingMode: RoundingMode;
      // 四捨五入
      if (fields.zeimarumeKbn === zeimarumeKbn.shishagonyu) {
        zeiRoundingMode = Big.roundHalfUp;
      }
      //切り捨て
      else if (fields.zeimarumeKbn === zeimarumeKbn.kirisute) {
        zeiRoundingMode = Big.roundDown;
      }
      //切り上げ
      else if (fields.zeimarumeKbn === zeimarumeKbn.kiriage) {
        zeiRoundingMode = Big.roundUp;
      }

      // 消費税合計 ※小数点以下は得意先毎の丸め処理を行う
      zeiGokei = juchuKinGokei
        .times(new Big(fields.zeiRitsu ?? "0"))
        .div(new Big("100"))
        .round(0, zeiRoundingMode!);
    }

    // 伝票合計
    const denpyoGokei: Big = juchuKinGokei.plus(zeiGokei);

    methods.setValue("juchuKinGokei", juchuKinGokei.toString());
    methods.setValue("zeiGokei", zeiGokei.toString());
    methods.setValue("denpyoGokei", denpyoGokei.toString());
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    // データを保存
    setRowData(data);
    if (typeof data.juchugyoNo !== "undefined") {
      // 明細入力部を編集に変更する
      meiMethods.setValue("meiTab", false);
      // 明細入力部に値を設定する
      meiMethods.setValue("juchugyoNo", data.juchugyoNo);
      meiMethods.setValue(
        "uchiwakeKbn",
        getSCode(JuchuUchiwakeKbn, data.uchiwakeKbn ?? "0")
      );
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(
          JuchuSeisanhinKbn,
          data.juchuSeisanhinKbn ?? juchuSeisanhinKbn.nashi
        )
      );
      meiMethods.setValue("shohinCd", data.shohinCd);
      meiMethods.setValue("shohinCdBefore", data.shohinCdBefore);
      meiMethods.setValue("janCd", data.janCd);
      meiMethods.setValue("shohinNm", data.shohinNm);
      meiMethods.setValue("aiteCd", data.aiteCd);
      meiMethods.setValue("sokoCd", data.sokoCd);
      meiMethods.setValue("sokoNm", data.sokoNm);
      meiMethods.setValue("vol", data.vol);
      meiMethods.setValue("sotosunW", data.sotosunW);
      meiMethods.setValue("sotosunH", data.sotosunH);
      meiMethods.setValue("uchisunW", data.uchisunW);
      meiMethods.setValue("uchisunH", data.uchisunH);
      meiMethods.setValue("juchusu", data.juchusu);
      meiMethods.setValue("juchusuBefore", data.juchusuBefore);
      meiMethods.setValue("kanosu", data.kanosu);
      meiMethods.setValue("tenyuryokujodaiKbn", data.tenyuryokujodaiKbn);
      meiMethods.setValue("tenyuryokujuchuKbn", data.tenyuryokujuchuKbn);
      meiMethods.setValue("basejodaitanka", data.basejodaitanka);
      meiMethods.setValue("basejuchutanka", data.basejuchutanka);
      meiMethods.setValue("jodaitanka", data.jodaitanka);
      meiMethods.setValue("juchutanka", data.juchutanka);
      meiMethods.setValue("kakeritsu", data.kakeritsu);
      meiMethods.setValue("juchuKin", data.juchuKin);
      meiMethods.setValue("meisaibikoCd", data.meisaibikoCd);
      meiMethods.setValue("meisaibikoCdBefore", data.meisaibikoCd);
      meiMethods.setValue("meisaibiko", data.meisaibiko);
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, data.kazeiKbn ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", data.kazeiKbn);
      meiMethods.setValue("setshohinKbn", data.setshohinKbn);
      meiMethods.setValue("edishohinNm", data.edishohinNm);
      meiMethods.setValue("crtDate", data.crtDate);
      meiMethods.setValue("crtshainCd", data.crtshainCd);
      meiMethods.setValue("shohinshubetsuKbn", data.shohinshubetsuKbn);
      meiMethods.setValue("tankaKbn", data.tankaKbn);
      meiMethods.setValue("shokuchiKbn", data.shokuchiKbn);
      meiMethods.setValue("whtankaCd", data.whtankaCd);
      meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
      meiMethods.setValue("zairyohikiatesuBefore", data.zairyohikiatesuBefore);
      meiMethods.setValue(
        "zairyohikiateKanoNagasa",
        data.zairyohikiateKanoNagasa
      );
      meiMethods.setValue("zairyohikiateNagasa", data.zairyohikiateNagasa);
      meiMethods.setValue("koseiData", data.koseiData);
      focus(35);
      reRendering();
    }
  };

  // 在庫照会ダイアログの引数を設定
  const [b000220DialogProps, setB000220DialogProps] = useState<B000220Props>();
  const updateB000220DialogProps = () => {
    setB000220DialogProps({
      shohinCd: meiMethods.watch("shohinCd"),
    });
    reRendering();
  };

  // 担当者照会ダイアログの引数を設定
  const [b000140DialogProps, setB000140DialogProps] = useState<B000140Props>();
  const updateB000140DialogProps = () => {
    setB000140DialogProps({
      eigyoCd: methods.watch("eigyoCd"),
      bumonCd: methods.watch("bumonCd"),
    });
    reRendering();
  };

  // 添付伝票照会ダイアログの引数を設定
  const [tenpudenpyoDialogProps, setTenpudenpyoDialogProps] =
    useState<B000111Props>();
  const updateTenpudenpyoDialogProps = () => {
    setTenpudenpyoDialogProps({
      meishoKbn: "34",
      denpyoshubetsuCd: methods.watch("denpyoshubetsuCd"),
    });
    reRendering();
  };

  // 納入先照会ダイアログの引数を設定
  const [nonyuDialogProps, setNonyuDialogProps] = useState<{
    tokuiCd?: string;
    tokuishitenCd?: string;
    torihikishuryoYmd?: string;
  }>({});
  const updateNonyuDialogProps = () => {
    setNonyuDialogProps({
      tokuiCd: methods.watch("tokuiCd"),
      tokuishitenCd: methods.watch("tokuishitenCd"),
      torihikishuryoYmd: torihikishuryoYmd,
    });
    reRendering();
  };

  // 補足の引数を設定
  const [supplementProps, setSupplementProps] = useState<B010011Props>();
  const updateSupplementProps = () => {
    setSupplementProps({
      editKbn: methods.getValues("editKbn"),
      juchudenpyoNo: methods.watch("juchudenpyoNo"),
      tokuiNm: methods.watch("tokuiNm"),
      tokuiPostCd: methods.watch("tokuiPostCd"),
      tokuiAddress1: methods.watch("tokuiAddress1"),
      tokuiAddress2: methods.watch("tokuiAddress2"),
      tokuiTelNo: methods.watch("tokuiTelNo"),
      tokuiFaxNo: methods.watch("tokuiFaxNo"),
      nonyuNm: methods.watch("nonyuNm"),
      nonyuPostCd: methods.watch("nonyuPostCd"),
      nonyuAddress1: methods.watch("nonyuAddress1"),
      nonyuAddress2: methods.watch("nonyuAddress2"),
      nonyuTelNo: methods.watch("nonyuTelNo"),
      nonyuFaxNo: methods.watch("nonyuFaxNo"),
      ediMemo: methods.watch("ediMemo"),
      nonyuShokuchiKbn: methods.watch("nonyuShokuchiKbn"),
    });
    reRendering();
  };

  // セット構成品の引数を設定
  const [b010012Props, setB010012Props] = useState<B010012Props>({
    editKbn: methods.getValues("editKbn"),
    fields: {},
    data: [],
    meiMethods: meiMethods,
  });
  const updateB010012Props = () => {
    setB010012Props({
      editKbn: methods.getValues("editKbn"),
      fields: {
        setshohinCd: meiMethods.watch("shohinCd"),
        setshohinNm: meiMethods.watch("shohinNm"),
        juchusu: meiMethods.watch("juchusu"),
        zeiRitsu: methods.watch("zeiRitsu"),
        tokuiCd: methods.watch("tokuiCd"),
        denpyoYmd: methods.watch("denpyoYmd"),
        tokuishitenCd: methods.watch("tokuishitenCd"),
        zeimarumeKbn: methods.watch("zeimarumeKbn"),
        kinmarumeKbn: methods.watch("kinmarumeKbn"),
        tankamarumeKbn: methods.watch("tankamarumeKbn"),
        tankahasuichi: methods.watch("tankahasuichi"),
        zeiKbn: methods.watch("zeiKbn"),
        tankaKakeritsu: methods.watch("tankaKakeritsu"),
        jodaihyojiKbn: methods.watch("jodaihyojiKbn"),
        isJuchuWork: false,
      },
      data: meiMethods.watch("koseiData")?.map((value) => ({
        juchugyoNo: value.juchugyoNo,
        juchukoseigyoNo: value.juchukoseigyoNo,
        shohinCd: value.shohinCd,
        shohinCdBefore: value.shohinCdBefore,
        janCd: value.janCd,
        shohinNm: value.shohinNm,
        sokoCd: value.sokoCd,
        sokoNm: value.sokoNm,
        aiteCd: value.aiteCd,
        sotosunW: value.sotosunW,
        sotosunH: value.sotosunH,
        uchisunW: value.uchisunW,
        uchisunH: value.uchisunH,
        hitsuyosu: value.hitsuyosu,
        hitsuyosuBefore: value.hitsuyosuBefore,
        koseisu: value.koseisu,
        vol: value.vol,
        kanosu: value.kanosu,
        tenyuryokujodaiKbn: value.tenyuryokujodaiKbn,
        tenyuryokujuchuKbn: value.tenyuryokujuchuKbn,
        basejodaitanka: value.jodaitanka,
        basejuchutanka: value.juchutanka,
        jodaitanka: value.jodaitanka,
        juchutanka: value.juchutanka,
        kakeritsu: value.kakeritsu,
        juchuKin: value.juchuKin,
        meisaikoseiBikoCd: value.meisaikoseiBikoCd,
        meisaikoseiBiko: value.meisaikoseiBiko,
        kazeiKbn: value.kazeiKbn,
        shohinshubetsuKbn: value.shohinshubetsuKbn,
        tankaKbn: value.tankaKbn,
        shokuchiKbn: value.shokuchiKbn,
        whtankaCd: value.whtankaCd,
        setshohinKbn: value.setshohinKbn,
        sokoshubetsuKbn: value.sokoshubetsuKbn,
        zairyohikiatesuBefore: value.zairyohikiatesuBefore,
        zairyohikiateKanoNagasa: value.zairyohikiateKanoNagasa,
        zairyohikiateNagasa: value.zairyohikiateNagasa,
        crtDate: value.crtDate,
        crtshainCd: value.crtshainCd,
      })),
      meiMethods: meiMethods,
    });
    reRendering();
  };

  // セット構成品の引数を設定(返却)
  const setKoseiProps = (b010012Props: B010012Props) => {
    const koseiDataList: KoseiData[] = [];

    // 受注数
    meiMethods.setValue("juchusu", b010012Props.fields?.juchusu);
    // 上代単価
    meiMethods.setValue("jodaitanka", b010012Props.fields?.setjodaitanka);
    // 下代単価
    meiMethods.setValue("juchutanka", b010012Props.fields?.setjuchutanka);

    // 掛率の再計算
    const kakeritsu: string = getKakeritsu(
      b010012Props.fields?.setjuchutanka!,
      b010012Props.fields?.setjodaitanka!
    );
    meiMethods.setValue("kakeritsu", kakeritsu);

    // 受注金額の再計算
    handleCalcJuchuKin();

    if (Object.keys(b010012Props!.data!).length === 0) {
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi)
      );

      meiMethods.setValue("koseiData", koseiDataList);
      return;
    }

    // 構成品の中に受注生産品が含まれるかどうか
    const isJuchuSeisanhinKbn: boolean = b010012Props!.data!.some(
      (koseiData) =>
        koseiData.shohinshubetsuKbn === shohinshubetsuKbn.madeToOrder
    );

    meiMethods.setValue(
      "juchuSeisanhinKbn",
      getSCode(
        JuchuSeisanhinKbn,
        isJuchuSeisanhinKbn ? juchuSeisanhinKbn.ari : juchuSeisanhinKbn.nashi
      )
    );

    // 構成品データ
    for (let i: number = 0; i < b010012Props!.data!.length; i++) {
      const koseiData: KoseiData = {
        juchukoseigyoNo: b010012Props!.data![i].juchukoseigyoNo,
        shohinCd: b010012Props!.data![i].shohinCd,
        shohinCdBefore: b010012Props!.data![i].shohinCdBefore,
        janCd: b010012Props!.data![i].janCd,
        shohinNm: b010012Props!.data![i].shohinNm,
        aiteCd: b010012Props!.data![i].aiteCd,
        sokoCd: b010012Props!.data![i].sokoCd,
        sokoNm: b010012Props!.data![i].sokoNm,
        vol: b010012Props!.data![i].vol,
        sotosunW: b010012Props!.data![i].sotosunW,
        sotosunH: b010012Props!.data![i].sotosunH,
        uchisunW: b010012Props!.data![i].uchisunW,
        uchisunH: b010012Props!.data![i].uchisunH,
        hitsuyosu: b010012Props!.data![i].hitsuyosu,
        hitsuyosuBefore: b010012Props!.data![i].hitsuyosuBefore,
        koseisu: b010012Props!.data![i].koseisu,
        kanosu: b010012Props!.data![i].kanosu,
        tenyuryokujodaiKbn: b010012Props!.data![i].tenyuryokujodaiKbn,
        tenyuryokujuchuKbn: b010012Props!.data![i].tenyuryokujuchuKbn,
        basejodaitanka: b010012Props!.data![i].basejodaitanka,
        basejuchutanka: b010012Props!.data![i].basejuchutanka,
        jodaitanka: b010012Props!.data![i].jodaitanka,
        juchutanka: b010012Props!.data![i].juchutanka,
        kakeritsu: b010012Props!.data![i].kakeritsu,
        juchuKin: b010012Props!.data![i].juchuKin,
        meisaikoseiBikoCd: b010012Props!.data![i].meisaikoseiBikoCd,
        meisaikoseiBiko: b010012Props!.data![i].meisaikoseiBiko,
        kazeiKbn: b010012Props!.data![i].kazeiKbn,
        shohinshubetsuKbn: b010012Props!.data![i].shohinshubetsuKbn,
        tankaKbn: b010012Props!.data![i].tankaKbn,
        shokuchiKbn: b010012Props!.data![i].shokuchiKbn,
        whtankaCd: b010012Props!.data![i].whtankaCd,
        sokoshubetsuKbn: b010012Props!.data![i].sokoshubetsuKbn,
        setshohinKbn: b010012Props!.data![i].setshohinKbn,
        zairyohikiatesuBefore: b010012Props!.data![i].zairyohikiatesuBefore,
        zairyohikiateKanoNagasa: b010012Props!.data![i].zairyohikiateKanoNagasa,
        zairyohikiateNagasa: b010012Props!.data![i].zairyohikiateNagasa,
        crtDate: b010012Props!.data![i].crtDate,
        crtshainCd: b010012Props!.data![i].crtshainCd,
      };

      koseiDataList.push(koseiData);
    }

    meiMethods.setValue("koseiData", koseiDataList);

    // 明細入力部に表示する可能数の設定
    let kanosu: string = "";
    // 構成品に可能数の設定されている行があるかチェック
    const isKanosu: boolean = koseiDataList.some(
      (koseiData: KoseiData) => koseiData.kanosu !== ""
    );
    // 可能数の設定されている行がある場合
    if (isKanosu) {
      kanosu = Math.min(
        ...koseiDataList
          .filter(function (kosei: KoseiData) {
            return kosei.kanosu !== "";
          })
          .map((kosei: KoseiData) => Number(kosei.kanosu))
      ).toString();
    }
    meiMethods.setValue("kanosu", kanosu);
    reRendering();
  };

  // レイアウト
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="受注入力"
          gridTemplateColumns="6rem 5rem 5rem 5rem 4rem 4rem 7rem 7rem 5rem 4rem 6rem 4rem 7rem 5rem 4rem"
        >
          <SInfoButton
            label={labels.buttons.supplement}
            gridColumn={!isReference() ? "-3" : "-1"}
            onClick={updateSupplementProps}
            dialog={<B010011 {...supplementProps} />}
            dialogAction="close"
            handleSubmit={(data: any) => {
              methods.setValue("nonyuNm", data.nonyuNm);
              methods.setValue("nonyuPostCd", data.nonyuPostCd);
              methods.setValue("nonyuAddress1", data.nonyuAddress1);
              methods.setValue("nonyuAddress2", data.nonyuAddress2);
              methods.setValue("nonyuTelNo", data.nonyuTelNo);
              methods.setValue("nonyuFaxNo", data.nonyuFaxNo);
              reRendering();
            }}
          />
          {!isReference() && (
            <>
              {methods.getValues().juchudenpyoNo === "" ? (
                <SNormalButton
                  label={labels.buttons.create}
                  onClick={handleOpenCreateConfirm}
                />
              ) : (
                <SNormalButton
                  label={labels.buttons.update}
                  onClick={handleOpenUpdateConfirm}
                />
              )}
            </>
          )}
          <SLabel required gridColumn={1}>
            受注区分
          </SLabel>
          <SCodeSelect
            label="受注区分"
            name="juchuKbn"
            required
            options={JuchuKbn}
            {...register(1)}
            gridColumn="span 2"
            onChange={handleOpenConfirm}
            disabled={isReference() || isUpdate()}
          />
          <SLabel>製作日</SLabel>
          <SDateField
            name="seisakuYmd"
            {...register(9)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel required>伝票日付</SLabel>
          <SDateField
            label="伝票日付"
            name="denpyoYmd"
            required
            {...register(13)}
            gridColumn="span 2"
            onBlur={() => handleChangeDenpyoYmd()}
            onAccept={handleChangeDenpyoYmd}
            disabled={isReference()}
          />
          <STextField name="shimeD" disabled />
          <SLabel>伝票種別</SLabel>
          <SNumberField
            name="denpyoshubetsuCd"
            code
            size={3}
            {...register(18)}
            onBlur={handleChangeDenpyoshubetsu}
            dialog={<B000111 meishoKbn={meishoKbn.denpyoshubetsu} />}
            handleSubmit={(data: any) => {
              methods.setValue("denpyoshubetsuCd", data?.meishoCd);
              methods.setValue("denpyoshubetsuNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference()}
          />
          <STextField name="denpyoshubetsuNm" disabled />
          <SLabel>伝票区分</SLabel>
          <SNumberField
            name="denpyoKbn"
            code
            size={3}
            {...register(25)}
            disabled={isReference()}
          />

          <SLabel gridColumn="1">受注No</SLabel>
          <SNumberField
            name="juchudenpyoNo"
            code
            size={10}
            disabled
            gridColumn="span 2"
          />
          <SLabel required>発送日</SLabel>
          <SDateField
            label="発送日"
            name="shukayoteiYmd"
            required
            {...register(10)}
            gridColumn="span 2"
            disabled={isReference()}
            onBlur={() => handleChangeShukayoteiYmd()}
            onAccept={handleChangeShukayoteiYmd}
          />
          <SLabel required>売上区分</SLabel>
          <SCodeSelect
            label="売上区分"
            name="chohaKbn"
            required
            {...register(14)}
            options={ChohaKbn}
            gridColumn="span 3"
            disabled={isReference()}
          />
          <SLabel>添付伝票</SLabel>
          <SNumberField
            name="tenpudenpyoCd"
            code
            size={3}
            {...register(19)}
            onBlur={handleChangeTenpudenpyo}
            onClick={updateTenpudenpyoDialogProps}
            dialog={<B000111 {...tenpudenpyoDialogProps} />}
            handleSubmit={(data: any) => {
              methods.setValue("tenpudenpyoCd", data?.meishoCd);
              methods.setValue("tenpudenpyoNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference() || isTenpudenpyoCdDisabled()}
          />
          <STextField name="tenpudenpyoNm" disabled />
          <SLabel>率</SLabel>
          <SNumberField
            name="ritsu"
            size={6}
            {...register(26)}
            disabled={isReference()}
          />

          <SLabel required>受注日</SLabel>
          <SDateField
            label="受注日"
            required
            name="juchuYmd"
            {...register(2)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel>必着日</SLabel>
          <SDateField
            name="nohinyoteiYmd"
            {...register(11)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel required>発送先</SLabel>
          <SCodeSelect
            label="発送先"
            name="hasosakiCd"
            required
            {...register(15)}
            options={HasosakiCd}
            gridColumn="span 3"
            disabled={isReference()}
          />
          <SLabel>分類</SLabel>
          <SNumberField
            name="bunrui"
            code
            size={4}
            {...register(20)}
            disabled={isReference()}
          />

          <SLabel gridColumn="4">持参日</SLabel>
          <SDateField
            name="jisanYmd"
            {...register(12)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel required gridColumn="7">
            発送区分
          </SLabel>
          <SCodeSelect
            label="発送区分"
            name="hasokbnCd"
            required
            {...register(16)}
            options={HasokbnCd}
            gridColumn="span 3"
            disabled={isReference()}
          />
          <SLabel>運送会社</SLabel>
          <SNumberField
            name="unsogaishaCd"
            code
            size={4}
            {...register(21)}
            onBlur={handleChangeUnsogaisha}
            dialog={<B000111 meishoKbn="32" />}
            handleSubmit={(data: any) => {
              methods.setValue("unsogaishaCd", data?.meishoCd);
              methods.setValue("unsogaishaNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference()}
          />
          <STextField name="unsogaishaNm" disabled gridColumn="span 3" />

          <SLabel required gridColumn="1">
            得意先
          </SLabel>
          <SNumberField
            label="得意先コード"
            name="tokuiCd"
            code
            size={6}
            {...register(3)}
            onBlur={handleChangeTokui}
            required
            disabled={isMikomiSeisanhin() || isReference()}
          />
          <SNumberField
            label="得意先支店コード"
            name="tokuishitenCd"
            code
            size={4}
            {...register(4)}
            onBlur={handleChangeTokui}
            required
            disabled={isMikomiSeisanhin() || isReference()}
            dialog={<B000150 torihikishuryoYmd={torihikishuryoYmd} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuiCd", data.tokuiCd);
              methods.setValue("tokuishitenCd", data.tokuishitenCd);
              methods.setValue("tokuiNm", data.tokuiNm1);

              // 得意先関連項目設定
              (async () => {
                await B010010Tokui(methods, navigate, setMsg);
                reRendering();
              })();
            }}
          />
          <STextField
            label="得意先名"
            name="tokuiNm"
            size={40}
            required
            gridColumn="span 3"
            disabled
          />
          <SLabel>消費税区分</SLabel>
          <SCodeSelect
            name="zeiKbnView"
            options={ZeiKbn}
            disabled
            gridColumn="span 3"
          />
          <SLabel>受注担当部門</SLabel>
          <STextField name="bumonCd" size={6} disabled />
          <STextField name="bumonNm" disabled gridColumn="span 3" />

          <SLabel required gridColumn="1">
            納入先
          </SLabel>
          <SNumberField
            label="納入先"
            name="nonyuCd"
            code
            size={6}
            required
            {...register(5)}
            onBlur={handleChangeNonyu}
            disabled={isMikomiSeisanhin() || isReference()}
          />
          <SNumberField
            label="納入先支店コード"
            name="nonyushitenCd"
            code
            size={4}
            required
            {...register(6)}
            onBlur={handleChangeNonyu}
            disabled={isMikomiSeisanhin() || isReference()}
            onClick={updateNonyuDialogProps}
            dialog={<B000151 {...nonyuDialogProps} />}
            handleSubmit={(data: any) => {
              methods.setValue("nonyuCd", data.nonyuCd);
              methods.setValue("nonyushitenCd", data.nonyushitenCd);
              methods.setValue("nonyuNm", data.tokuiNm1);

              // 納入関連項目設定
              (async () => {
                await B010010Nonyu(methods, navigate, setMsg);
                reRendering();
              })();
            }}
          />
          <STextField
            label="納入先名"
            name="nonyuNm"
            size={40}
            required
            {...register(7)}
            disabled={!isNonyuShokuchi() || isReference()}
            gridColumn="span 3"
          />
          <SLabel required>アシスタント</SLabel>
          <SNumberField
            label="アシスタント"
            name="assistantCd"
            code
            size={7}
            required
            {...register(17)}
            onBlur={handleChangeAssistant}
            onClick={updateB000140DialogProps}
            dialog={<B000140 {...b000140DialogProps} />}
            handleSubmit={(data: any) => {
              methods.setValue("assistantCd", data.shainCd);
              methods.setValue("assistantNm", data.shainNm);
              reRendering();
            }}
            disabled={isReference()}
          />

          <STextField name="assistantNm" disabled gridColumn="span 2" />
          <SLabel required>PP掛け</SLabel>
          <SCodeSelect
            label="PP掛け"
            name="ppgakeKbn"
            required
            {...register(22)}
            options={PpgakeKbn}
            disabled={isReference()}
          />
          <SLabel required gridColumn="14">
            値付け
          </SLabel>
          <SCodeSelect
            label="値付け"
            name="netsukeKbn"
            required
            {...register(23)}
            options={NetsukeKbn}
            disabled={isReference()}
          />

          <SLabel required gridColumn="1">
            受注担当者
          </SLabel>
          <SNumberField
            label="受注担当者"
            name="shainCd"
            code
            size={7}
            required
            {...register(8)}
            onBlur={handleChangeShain}
            onClick={updateB000140DialogProps}
            dialog={<B000140 {...b000140DialogProps} />}
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data.shainCd);
              methods.setValue("shainNm", data.shainNm);
              methods.setValue("bumonCd", data.bumonCd);
              methods.setValue("bumonNm", data.bumonNm);
              methods.setValue("eigyoCd", data.eigyoCd);
              reRendering();
            }}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <STextField name="shainNm" disabled gridColumn="span 3" />
          <SLabel gridColumn="11">客先No.</SLabel>
          <STextField
            name="chumonNo"
            size={10}
            {...register(24)}
            gridColumn="span 2"
            disabled={isReference()}
          />

          <SText gridColumn="1">　</SText>

          <SLabel gridColumn="1">品別番号</SLabel>
          <STextField
            name="hinbetsuNo"
            code
            size={10}
            {...register(27)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel>納品先</SLabel>
          <STextField
            name="nohinsaki"
            size={20}
            {...register(31)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel>売場名</SLabel>
          <STextField
            name="uribaNm"
            size={16}
            {...register(33)}
            gridColumn="span 3"
            disabled={isReference()}
          />
          <SLabel>内線</SLabel>
          <STextField
            name="naisen"
            size={13}
            {...register(34)}
            gridColumn="span 2"
            disabled={isReference()}
          />

          <SLabel gridColumn="1">担当者</SLabel>
          <STextField
            name="tantosha"
            size={16}
            {...register(28)}
            gridColumn="span 2"
            disabled={isReference()}
          />
          <SLabel>ラインNo.</SLabel>
          <SNumberField
            name="lineCd"
            code
            size={3}
            {...register(32)}
            onBlur={handleChangeLine}
            dialog={<B000111 meishoKbn="31" />}
            handleSubmit={(data: any) => {
              methods.setValue("lineCd", data?.meishoCd);
              methods.setValue("lineNm", data?.meishoNm1);
              reRendering();
            }}
            disabled={isReference()}
          />
          <STextField name="lineNm" disabled gridColumn="span 2" />
          <SLabel gridColumn="11">EDI受注番号</SLabel>
          <STextField name="edijuchuNo" disabled gridColumn="span 2" />
          <SLabel gridColumn="1">受注備考</SLabel>
          <SNumberField
            name="bikoCd"
            code="true"
            size={3}
            {...register(29)}
            onBlur={handleChangeBiko}
            dialog={<B000111 meishoKbn="2" />}
            handleSubmit={(data: any) => {
              methods.setValue("bikoCd", data?.meishoCd);
              methods.setValue("biko", data?.meishoNm1);
              methods.setValue("bikoCdBefore", data?.meishoCd);
              reRendering();
            }}
            disabled={isReference()}
          />
          <STextField
            name="biko"
            size={40}
            {...register(30)}
            gridColumn="span 4"
            disabled={isReference()}
          />

          <SText gridColumn="1"></SText>
          <Box display="grid" gridColumn="span 4 / 15" gridRow="span 1">
            <Box display="grid" gridTemplateColumns="8em 8em 8em">
              <SLabel>受注金額合計</SLabel>
              <SLabel>消費税</SLabel>
              <SLabel>伝票合計</SLabel>
              <SNumberField
                name="juchuKinGokei"
                size={9}
                align="right"
                disabled
              />
              <SNumberField name="zeiGokei" size={9} align="right" disabled />
              <SNumberField
                name="denpyoGokei"
                size={9}
                align="right"
                disabled
              />
            </Box>
          </Box>
        </SFrame>
      </FormProvider>
      <SFrame>
        <STable
          keyName="juchugyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          width="78rem"
          height={isReference() ? "25rem" : "10rem"}
          pageSize={20}
          handleDoubleClick={handleDoubleClickTableRow}
          rowSelectable={meiMethods.watch("meiTab")}
        />
      </SFrame>
      <FormProvider {...meiMethods}>
        <SFrame>
          <SEntryTab name="meiTab" handleOk={handleChangeMeiTab}></SEntryTab>
          <SFrame
            gridTemplateColumns="8rem 10rem 4rem 10rem 8rem 9rem 9rem 9rem 9rem"
            columnGap="3px"
            rowGap="2px"
          >
            <SLabel required>内訳区分</SLabel>
            <SLabel required gridColumn="span 2">
              商品コード
            </SLabel>
            <SLabel>JANコード</SLabel>
            <SLabel>WH(外)</SLabel>
            <SLabel required>受注数</SLabel>
            <SLabel>可能数</SLabel>
            <SLabel>上代</SLabel>
            <SLabel required>掛率</SLabel>
            <SCodeSelect
              label="内訳区分"
              name="uchiwakeKbn"
              required
              {...register(35)}
              options={JuchuUchiwakeKbn}
              disabled={isMeiDisabled() || isReference()}
            />
            <SNumberField
              label="商品コード"
              name="shohinCd"
              code
              size={10}
              required
              {...register(36)}
              onBlur={handleChangeShohinCd}
              disabled={isMeiDisabled() || isReference()}
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("janCd", data.janCd);
                meiMethods.setValue("shohinNm", data.shohinNm);
                (async () => {
                  await B010010Shohin(methods, meiMethods, navigate, setMsg);
                  reRendering();
                })();
              }}
            />
            <SInfoButton
              label={labels.buttons.component}
              disabled={isKoseiDisabled()}
              onClick={updateB010012Props}
              dialog={<B010012 {...b010012Props} />}
              dialogAction="close"
              handleSubmit={setKoseiProps}
            />
            <STextField
              name="janCd"
              {...register(37)}
              onBlur={handleChangeJanCd}
              disabled={isMeiDisabled() || isReference()}
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("janCd", data.janCd);
                meiMethods.setValue("shohinNm", data.shohinNm);
                (async () => {
                  // 商品関連項目設定
                  await B010010Shohin(methods, meiMethods, navigate, setMsg);
                  reRendering();
                })();
              }}
              code
              size={13}
            />
            <Box display="grid" gridTemplateColumns="3em auto 3em">
              <SNumberField
                name="sotosunW"
                {...register(41)}
                onBlur={handleChangeWhTanka}
                disabled={isMeiDisabled() || isReference()}
                size={4}
              />
              <SText>✕</SText>
              <SNumberField
                name="sotosunH"
                {...register(42)}
                onBlur={handleChangeWhTanka}
                disabled={isMeiDisabled() || isReference()}
                size={4}
              />
            </Box>
            {/* 受注生産品ORセット構成品の場合、在庫照会helpを非表示にする */}
            {isMeiJuchuSeisanhin() || isSetshohinKbn() ? (
              <SNumberField
                label="受注数"
                name="juchusu"
                required
                {...register(45)}
                onBlur={handleChangeJuchusu}
                disabled={isMeiDisabled() || isReference()}
                size={6}
              />
            ) : (
              <SNumberField
                label="受注数"
                name="juchusu"
                required
                {...register(45)}
                onBlur={handleChangeJuchusu}
                disabled={isMeiDisabled() || isReference()}
                size={6}
                onClick={updateB000220DialogProps}
                dialog={<B000220 {...b000220DialogProps} />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("shohinCd", data.shohinCd);
                  meiMethods.setValue("janCd", data.janCd);
                  meiMethods.setValue("shohinNm", data.shohinNm);
                  meiMethods.setValue("sokoCd", data.sokoCd);
                  meiMethods.setValue("sokoNm", data.sokoNm);
                  meiMethods.setValue("kanosu", data.hikiatekanosu);
                  meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
                  // 商品関連項目設定
                  (async () => {
                    await B010010ShohinZaiko(
                      methods,
                      meiMethods,
                      navigate,
                      setMsg
                    );
                    reRendering();
                  })();
                }}
              />
            )}
            <SNumberField name="kanosu" disabled size={6} />
            <SNumberField
              name="jodaitanka"
              {...register(46)}
              onBlur={handleCalcJuchutankaJuchuKin}
              disabled={isMeiDisabled() || isSetshohinKbn() || isReference()}
              size={7}
            />
            <SNumberField
              label="掛率"
              name="kakeritsu"
              required
              {...register(47)}
              onBlur={handleCalcJuchutankaJuchuKin}
              disabled={isMeiDisabled() || isSetshohinKbn() || isReference()}
              size={3}
              scale={0}
            />
            <SLabel>受注生産品</SLabel>
            <SLabel gridColumn="span 3">商品名</SLabel>
            <SLabel>WH(内)</SLabel>
            <SLabel>VOL</SLabel>
            <SLabel>課税</SLabel>
            <SLabel required>下代</SLabel>
            <SLabel required>金額</SLabel>
            <SCodeSelect
              name="juchuSeisanhinKbn"
              disabled
              options={JuchuSeisanhinKbn}
            />
            <STextField
              name="shohinNm"
              {...register(39)}
              gridColumn="span 3"
              disabled={
                isMeiDisabled() || !isShohinShokuchiKbn() || isReference()
              }
              size={40}
            />
            <Box display="grid" gridTemplateColumns="3em auto 3em">
              <SNumberField
                name="uchisunW"
                {...register(43)}
                disabled={isMeiDisabled() || isReference()}
                size={4}
              />
              <SText>✕</SText>
              <SNumberField
                name="uchisunH"
                {...register(44)}
                disabled={isMeiDisabled() || isReference()}
                size={4}
              />
            </Box>
            <STextField name="vol" disabled />
            <STextField name="kazeiKbnView" disabled />
            <SNumberField
              label="下代"
              name="juchutanka"
              required
              {...register(48)}
              onBlur={handleCalcJuchuKinFromJuchutanka}
              disabled={isMeiDisabled() || isSetshohinKbn() || isReference()}
              size={7}
            />
            <SNumberField
              label="金額"
              name="juchuKin"
              required
              {...register(49)}
              disabled={
                isMeiDisabled() ||
                isKingakuDisabled() ||
                isSetshohinKbn() ||
                isReference()
              }
              size={9}
            />
            <SLabel required gridColumn="2/4">
              倉庫
            </SLabel>
            <SLabel>相手コード</SLabel>
            <SLabel gridColumn="5/10">受注明細備考</SLabel>
            <Box display="grid" gridColumn="2/4" gridTemplateColumns="5em 1fr">
              <STextField
                label="倉庫コード"
                name="sokoCd"
                {...register(38)}
                onBlur={handleChangeSokoCd}
                disabled={
                  isMeiDisabled() ||
                  isMeiJuchuSeisanhin() ||
                  isSetshohinKbn() ||
                  isReference()
                }
                dialog={<B000190 />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("sokoCd", data?.sokoCd);
                  meiMethods.setValue("sokoNm", data?.sokoNm);
                  meiMethods.setValue("sokoshubetsuKbn", data?.sokoshubetsuKbn);
                  // 引当可能数取得処理
                  (async () => {
                    await B010010Kanosu(meiMethods, navigate, setMsg);
                    reRendering();
                  })();
                }}
                size={3}
              />
              <STextField name="sokoNm" disabled gridColumn="2/3" />
            </Box>
            <STextField
              name="aiteCd"
              {...register(40)}
              disabled={isMeiDisabled() || isReference()}
              size={20}
            />
            <Box display="grid" gridColumn="5/10" gridTemplateColumns="5em 1fr">
              <SNumberField
                code
                name="meisaibikoCd"
                {...register(50)}
                disabled={isMeiDisabled() || isReference()}
                onBlur={() => B000111Meisaibiko(meiMethods, navigate, setMsg)}
                dialog={<B000111 meishoKbn="7" />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("meisaibikoCd", data?.meishoCd);
                  meiMethods.setValue("meisaibikoCdBefore", data?.meishoCd);
                  meiMethods.setValue("meisaibiko", data?.meishoNm1);
                  reRendering();
                }}
                size={3}
              />
              <STextField
                name="meisaibiko"
                {...register(51)}
                disabled={isMeiDisabled() || isReference()}
                size={20}
              />
            </Box>
            {!meiMethods.watch("meiTab") && (
              <SCancelButton
                label={labels.buttons.deleteDetail}
                gridRow="7"
                gridColumn="1"
                onClick={handleClickDeleteMeiButton}
                disabled={isReference()}
              />
            )}
            {meiMethods.watch("meiTab") ? (
              <SNormalButton
                label={labels.buttons.createDetail}
                {...register(56)}
                gridRow="7"
                gridColumn="9"
                align="right"
                onClick={handleClickCreateMeiButton}
                disabled={isReference()}
              />
            ) : (
              <SNormalButton
                label={labels.buttons.updateDetail}
                {...register(56)}
                gridRow="7"
                gridColumn="9"
                align="right"
                onClick={handleClickUpdateMeiButton}
                disabled={isReference()}
              />
            )}
          </SFrame>
        </SFrame>
        <SConfirmDialogAction
          msg={
            isMikomiSeisanhin()
              ? labels.dialog.juchuResetMikomi
              : labels.dialog.juchuResetTujo
          }
          onOk={handleChangeJuchuKbn}
          onCancel={handleCancelConfirm}
          isOpen={openJuchuKbnConfirm}
        />
        <SConfirmDialogAction
          msg={labels.dialog.createCheck}
          onOk={handleClickCreateButton}
          onCancel={handleCancelCreateConfirm}
          isOpen={openCreateConfirm}
        />
        <SConfirmDialogAction
          msg={labels.dialog.updateCheck}
          onOk={handleClickUpdateButton}
          onCancel={handleCancelUpdateConfirm}
          isOpen={openUpdateConfirm}
        />
      </FormProvider>
    </>
  );
};
